var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _path, _g, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153, _symbol154, _symbol155, _symbol156, _symbol157, _symbol158, _symbol159, _symbol160, _symbol161, _symbol162, _symbol163, _symbol164, _symbol165, _symbol166, _symbol167, _symbol168, _symbol169, _symbol170, _symbol171, _symbol172, _symbol173, _symbol174, _symbol175, _symbol176, _symbol177, _symbol178, _symbol179, _symbol180, _symbol181, _symbol182, _symbol183, _symbol184, _symbol185, _symbol186, _symbol187, _symbol188, _symbol189, _symbol190, _symbol191, _symbol192, _symbol193, _symbol194, _symbol195, _symbol196, _symbol197, _symbol198, _symbol199, _symbol200, _symbol201, _symbol202, _symbol203, _symbol204, _symbol205, _symbol206, _symbol207, _symbol208, _symbol209, _symbol210, _symbol211, _symbol212, _symbol213, _symbol214, _symbol215, _symbol216, _symbol217, _symbol218, _symbol219, _symbol220, _symbol221, _symbol222, _symbol223, _symbol224, _symbol225, _symbol226, _symbol227, _symbol228, _symbol229, _symbol230, _symbol231, _symbol232;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "3_dot_menu",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33334 4C1.33334 3.63181 1.63182 3.33334 2.00001 3.33334H14C14.3682 3.33334 14.6667 3.63181 14.6667 4C14.6667 4.36819 14.3682 4.66667 14 4.66667H2.00001C1.63182 4.66667 1.33334 4.36819 1.33334 4ZM1.33334 8C1.33334 7.63181 1.63182 7.33334 2.00001 7.33334H14C14.3682 7.33334 14.6667 7.63181 14.6667 8C14.6667 8.36819 14.3682 8.66667 14 8.66667H2.00001C1.63182 8.66667 1.33334 8.36819 1.33334 8ZM1.33334 12C1.33334 11.6318 1.63182 11.3333 2.00001 11.3333H14C14.3682 11.3333 14.6667 11.6318 14.6667 12C14.6667 12.3682 14.3682 12.6667 14 12.6667H2.00001C1.63182 12.6667 1.33334 12.3682 1.33334 12Z",
    fill: "currentColor"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "accessed_by_projects",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 3,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "accessed_data",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 2,
    fill: "currentColor"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 2,
    height: 16,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 16,
    height: 2,
    fill: "currentColor"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "add_to_graph_editor",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0H4.5V12H16V16H0V12H2.5V0ZM11.5 2H9.5V5H6.5V7H9.5V10H11.5V7H14.5V5H11.5V2Z",
    fill: "currentColor"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "array_new",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 6,
    y: 6,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 10,
    y: 6,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 1,
    height: 5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 3,
    height: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 3,
    height: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 3,
    height: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 3,
    height: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 1,
    height: 5,
    fill: "currentColor"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "array_new2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 4,
    y: 7,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 9,
    y: 7,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 2,
    height: 7,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 2,
    height: 7,
    transform: "rotate(-180 16 12)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 4,
    height: 2,
    transform: "rotate(-180 16 14)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 4,
    height: 2,
    transform: "rotate(-180 16 5)",
    fill: "currentColor"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_circle_left",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8H5.33333M5.33333 8L7.33333 10M5.33333 8L7.33333 6M2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_circle_right",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 8H10.6667M10.6667 8L8.66667 6M10.6667 8L8.66667 10M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_circle_up",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6667V5.33333M8 5.33333L6 7.33333M8 5.33333L10 7.33333M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_left",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80278 6.86851V4L2 7.86851L7.80278 11.737V8.86851H13.8028V6.86851H7.80278Z",
    fill: "currentColor"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_right",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.86852V11.737L13.8028 7.86852L8 4V6.86852H2V8.86852H8Z",
    fill: "currentColor"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_right_head_only",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 4L11 8L5 12V4Z",
    fill: "currentColor"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "at",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1579 13.1027C10.2407 13.6716 9.15868 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.28412 13.3618 10.6103 11.8734 10.475C10.6489 10.3637 9.7675 9.24915 9.94138 8.03194L10.2849 5.66667M9.90541 8.31166C9.70598 9.73067 8.53777 10.7395 7.29613 10.565C6.0545 10.3905 5.20962 9.09874 5.40905 7.67973C5.60848 6.26072 6.77669 5.25185 8.01833 5.42635C9.25996 5.60085 10.1048 6.89265 9.90541 8.31166Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "auto_replay",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9829 4L6.98291 0V3.00002C3.67706 3.00924 1 5.69199 1 9C1 9.85105 1.17719 10.6607 1.49669 11.3941L3.24597 10.3842C3.08688 9.95285 3 9.48657 3 9C3 6.79656 4.78163 5.00924 6.98291 5.00004V8L13.9829 4ZM14.3506 6.28229L12.6146 7.28463C12.8617 7.80448 13 8.38609 13 9C13 11.2091 11.2091 13 9 13H7C6.00325 13 5.09164 12.6354 4.39127 12.0323L2.59232 13.071C3.68848 14.2572 5.25749 15 7 15H9C12.3137 15 15 12.3137 15 9C15 8.02176 14.7659 7.0982 14.3506 6.28229Z",
    fill: "currentColor"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C10 2.02997 9.99934 2.05979 9.99804 2.08944C11.7151 2.46727 13 3.9978 13 5.82843V6.64298C13 8.15215 13.5995 9.59952 14.6667 10.6667C14.8801 10.8801 15 11.1696 15 11.4714V12C15 12.5523 14.5523 13 14 13H2C1.44772 13 1 12.5523 1 12V11.4714C1 11.1696 1.1199 10.8801 1.33333 10.6667C2.40048 9.59952 3 8.15215 3 6.64298V5.82843C3 3.9978 4.28486 2.46727 6.00196 2.08944C6.00066 2.05979 6 2.02997 6 2C6 0.895431 6.89543 0 8 0C9.10457 0 10 0.895431 10 2ZM9.84776 14.7654C9.94827 14.5227 10 14.2626 10 14H8H6C6 14.2626 6.05173 14.5227 6.15224 14.7654C6.25275 15.008 6.40007 15.2285 6.58579 15.4142C6.7715 15.5999 6.99198 15.7472 7.23463 15.8478C7.47728 15.9483 7.73736 16 8 16C8.26264 16 8.52272 15.9483 8.76537 15.8478C9.00802 15.7472 9.2285 15.5999 9.41421 15.4142C9.59993 15.2285 9.74725 15.008 9.84776 14.7654Z",
    fill: "currentColor"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "bold",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33334 3.33333C3.33334 2.59695 3.9303 2 4.66668 2H8.55557C10.5798 2 12.1111 3.70367 12.1111 5.66667C12.1111 6.38875 11.9039 7.07574 11.5412 7.65575C12.2407 8.3349 12.6667 9.29805 12.6667 10.3333C12.6667 12.2963 11.1354 14 9.11112 14H4.66668C3.9303 14 3.33334 13.403 3.33334 12.6667V3.33333ZM8.55557 6.66667C8.98593 6.66667 9.44445 6.281 9.44445 5.66667C9.44445 5.05233 8.98593 4.66667 8.55557 4.66667H6.00001V6.66667H8.55557ZM6.00001 9.33333H9.11112C9.54149 9.33333 10 9.719 10 10.3333C10 10.9477 9.54149 11.3333 9.11112 11.3333H6.00001V9.33333Z",
    fill: "currentColor"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "bookmark",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2C1 0.895431 1.89543 0 3 0H13C14.1046 0 15 0.895431 15 2V16L8 11L1 16V2Z",
    fill: "currentColor"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "bottom_panel",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.11884V10.8812C16 11.5967 16 12.1872 15.9607 12.6683C15.9199 13.1679 15.8323 13.6272 15.6125 14.0587C15.2716 14.7276 14.7277 15.2716 14.0586 15.6124C13.6272 15.8323 13.1679 15.9199 12.6683 15.9607C12.1872 16 11.5967 16 10.8812 16H5.11884C4.40329 16 3.8128 16 3.33173 15.9607C2.83209 15.9199 2.3728 15.8323 1.94133 15.6124C1.27236 15.2716 0.728445 14.7276 0.387556 14.0587C0.167734 13.6272 0.0800896 13.1679 0.0392896 12.6683C6.78831e-07 12.1872 -1.19209e-07 11.5967 -1.19209e-07 10.8812V5.11883C-1.19209e-07 4.40331 6.78831e-07 3.81277 0.0392896 3.33172C0.0800896 2.83207 0.167734 2.37277 0.387556 1.94137C0.728445 1.27235 1.27236 0.728417 1.94133 0.387533C2.3728 0.167719 2.83209 0.0801068 3.33173 0.0392844C3.8128 -1.96927e-05 4.40329 -1.06242e-05 5.11884 3.6591e-07H10.8812C11.5967 -1.06242e-05 12.1872 -1.9696e-05 12.6683 0.0392844C13.1679 0.0801068 13.6272 0.167719 14.0586 0.387533C14.7277 0.728417 15.2716 1.27235 15.6125 1.94137C15.8323 2.37277 15.9199 2.83207 15.9607 3.33172C16 3.81277 16 4.40331 16 5.11884ZM4.44444 10.6667C3.95351 10.6667 3.55556 11.0646 3.55556 11.5556C3.55556 12.0465 3.95351 12.4444 4.44444 12.4444H11.5556C12.0465 12.4444 12.4444 12.0465 12.4444 11.5556C12.4444 11.0646 12.0465 10.6667 11.5556 10.6667H4.44444Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 1 -1 0 16 0)"
  }))))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "braces",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1C4.5 1 3.5 2 3.5 3V6C3.5 6.5 3.49999 8 1 8C3.5 8 3.5 9.5 3.5 10V13C3.5 14 4.5 15 6 15M10 1C11.5 1 12.5 2 12.5 3V6C12.5 6.5 12.5 8 15 8C12.5 8 12.5 9.5 12.5 10V13C12.5 14 11.5 15 10 15",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "brush",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03992 14.4225C6.98964 14.0539 7.66138 13.1455 7.66138 12.0832C7.66138 10.6943 6.51298 9.56842 5.09636 9.56842C4.00537 9.56842 3.07345 10.2362 2.70268 11.1777H2.6654C2.01092 12.2083 0.982296 12.8985 -0.187469 12.9774C-0.128395 13.068 -0.064732 13.1568 0.00343032 13.2435C0.485832 13.857 1.1725 14.3391 1.97876 14.6303C2.78502 14.9216 3.67564 15.0093 4.54079 14.8825C5.07199 14.8047 5.57933 14.6482 6.03992 14.4225Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.631 1.40937C14.1659 0.874498 15.0331 0.874498 15.568 1.40937V1.40937C16.1028 1.94423 16.1028 2.81142 15.568 3.34629L8.30184 10.6124L6.36491 8.67548L13.631 1.40937Z",
    fill: "currentColor"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "bullet-list",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2.66667C2.89543 2.66667 2 3.5621 2 4.66667 2 5.77124 2.89543 6.66667 4 6.66667 5.10457 6.66667 6 5.77124 6 4.66667 6 3.5621 5.10457 2.66667 4 2.66667ZM8.66667 4C8.29848 4 8 4.29848 8 4.66667 8 5.03486 8.29848 5.33333 8.66667 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667 14 4.29848 13.7015 4 13.3333 4H8.66667ZM4 9.33333C2.89543 9.33333 2 10.2288 2 11.3333 2 12.4379 2.89543 13.3333 4 13.3333 5.10457 13.3333 6 12.4379 6 11.3333 6 10.2288 5.10457 9.33333 4 9.33333ZM8.66667 10.6667C8.29848 10.6667 8 10.9651 8 11.3333 8 11.7015 8.29848 12 8.66667 12H13.3333C13.7015 12 14 11.7015 14 11.3333 14 10.9651 13.7015 10.6667 13.3333 10.6667H8.66667Z",
    fill: "currentColor"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 4H16V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C3.44772 0 3 0.447715 3 1V2H2C0.895431 2 0 2.89543 0 4H4H12H16C16 2.89543 15.1046 2 14 2H13V1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1V2H5V1C5 0.447715 4.55228 0 4 0ZM3.5 12C2.94772 12 2.5 12.4477 2.5 13C2.5 13.5523 2.94772 14 3.5 14C4.05228 14 4.5 13.5523 4.5 13C4.5 12.4477 4.05228 12 3.5 12ZM2.5 10C2.5 9.44771 2.94772 9 3.5 9C4.05228 9 4.5 9.44771 4.5 10C4.5 10.5523 4.05228 11 3.5 11C2.94772 11 2.5 10.5523 2.5 10ZM3.5 6C2.94772 6 2.5 6.44772 2.5 7C2.5 7.55228 2.94772 8 3.5 8C4.05228 8 4.5 7.55228 4.5 7C4.5 6.44772 4.05228 6 3.5 6ZM5.5 13C5.5 12.4477 5.94772 12 6.5 12C7.05228 12 7.5 12.4477 7.5 13C7.5 13.5523 7.05228 14 6.5 14C5.94772 14 5.5 13.5523 5.5 13ZM6.5 9C5.94772 9 5.5 9.44771 5.5 10C5.5 10.5523 5.94772 11 6.5 11C7.05228 11 7.5 10.5523 7.5 10C7.5 9.44771 7.05228 9 6.5 9ZM5.5 7C5.5 6.44772 5.94772 6 6.5 6C7.05228 6 7.5 6.44772 7.5 7C7.5 7.55228 7.05228 8 6.5 8C5.94772 8 5.5 7.55228 5.5 7ZM9.5 12C8.94771 12 8.5 12.4477 8.5 13C8.5 13.5523 8.94771 14 9.5 14C10.0523 14 10.5 13.5523 10.5 13C10.5 12.4477 10.0523 12 9.5 12ZM8.5 10C8.5 9.44771 8.94771 9 9.5 9C10.0523 9 10.5 9.44771 10.5 10C10.5 10.5523 10.0523 11 9.5 11C8.94771 11 8.5 10.5523 8.5 10ZM9.5 6C8.94771 6 8.5 6.44772 8.5 7C8.5 7.55228 8.94771 8 9.5 8C10.0523 8 10.5 7.55228 10.5 7C10.5 6.44772 10.0523 6 9.5 6ZM11.5 10C11.5 9.44771 11.9477 9 12.5 9C13.0523 9 13.5 9.44771 13.5 10C13.5 10.5523 13.0523 11 12.5 11C11.9477 11 11.5 10.5523 11.5 10ZM12.5 6C11.9477 6 11.5 6.44772 11.5 7C11.5 7.55228 11.9477 8 12.5 8C13.0523 8 13.5 7.55228 13.5 7C13.5 6.44772 13.0523 6 12.5 6Z",
    fill: "currentColor"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "camera",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70711 1.29289C5.89464 1.10536 6.149 1 6.41421 1H9.58579C9.851 1 10.1054 1.10536 10.2929 1.29289L12 3H4L5.70711 1.29289Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C1.34315 3 0 4.34315 0 6V12C0 13.6569 1.34315 15 3 15H13C14.6569 15 16 13.6569 16 12V6C16 4.34315 14.6569 3 13 3H3ZM8 12.7C10.2091 12.7 12 10.9091 12 8.7C12 6.49086 10.2091 4.7 8 4.7C5.79086 4.7 4 6.49086 4 8.7C4 10.9091 5.79086 12.7 8 12.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.7,
    r: 2.25,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "chat",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C12.4183 15 16 11.6421 16 7.5C16 3.35786 12.4183 0 8 0C3.58172 0 0 3.35786 0 7.5C0 9.08162 0.52221 10.5489 1.4138 11.7585L1.12093e-05 16L4.18897 14.0959C5.32198 14.6725 6.6202 15 8 15Z",
    fill: "currentColor"
  })))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3936 2.12864C14.6908 2.34604 14.7555 2.76317 14.538 3.06032L6.73413 13.727C6.62702 13.8734 6.46488 13.9698 6.2851 13.994C6.10533 14.0183 5.92344 13.9682 5.78141 13.8554L1.58533 10.522C1.29703 10.293 1.24898 9.87363 1.478 9.58534C1.70702 9.29704 2.12639 9.24899 2.41468 9.47801L6.06762 12.3799L13.462 2.27304C13.6794 1.97589 14.0965 1.91124 14.3936 2.12864Z",
    fill: "currentColor"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-list",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06667 3.46667C6.36122 3.68758 6.42091 4.10545 6.2 4.4L4.2 7.06667C3.98771 7.34973 3.59126 7.41764 3.29687 7.22137L2.29687 6.5547C1.99051 6.35047 1.90773 5.93656 2.11197 5.6302C2.3162 5.32385 2.73011 5.24107 3.03647 5.4453L3.51173 5.76214L5.13333 3.6C5.35425 3.30545 5.77211 3.24576 6.06667 3.46667ZM8 5.33334C8 4.96515 8.29848 4.66667 8.66667 4.66667H13.3333C13.7015 4.66667 14 4.96515 14 5.33334C14 5.70153 13.7015 6 13.3333 6H8.66667C8.29848 6 8 5.70153 8 5.33334ZM6.06667 8.8C6.36122 9.02092 6.42091 9.43879 6.2 9.73334L4.2 12.4C3.98771 12.6831 3.59126 12.751 3.29687 12.5547L2.29687 11.888C1.99051 11.6838 1.90773 11.2699 2.11197 10.9635C2.3162 10.6572 2.73011 10.5744 3.03647 10.7786L3.51173 11.0955L5.13333 8.93334C5.35425 8.63879 5.77211 8.57909 6.06667 8.8ZM8 10.6667C8 10.2985 8.29848 10 8.66667 10H13.3333C13.7015 10 14 10.2985 14 10.6667C14 11.0349 13.7015 11.3333 13.3333 11.3333H8.66667C8.29848 11.3333 8 11.0349 8 10.6667Z",
    fill: "currentColor"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "clone",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0.666656H2.99999C2.26666 0.666656 1.66666 1.26666 1.66666 1.99999V11.3333H2.99999V1.99999H11V0.666656ZM10.3333 3.33332L14.3333 7.33332V14C14.3333 14.7333 13.7333 15.3333 13 15.3333H5.65999C4.92666 15.3333 4.33332 14.7333 4.33332 14L4.33999 4.66666C4.33999 3.93332 4.93332 3.33332 5.66666 3.33332H10.3333ZM9.66666 7.99999H13.3333L9.66666 4.33332V7.99999Z",
    fill: "currentColor"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6L6 10M10 10L6 6M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "close_tab",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2 8C2 5.79086 3.79086 4 6 4H10C12.2091 4 14 5.79086 14 8V12H2V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1173 3.12132C15.5078 2.7308 15.5078 2.09763 15.1173 1.70711C14.7268 1.31658 14.0936 1.31658 13.7031 1.70711L9.70715 5.70305C9.31663 6.09358 9.31663 6.72674 9.70715 7.11727C10.0977 7.50779 10.7308 7.50779 11.1214 7.11727L15.1173 3.12132Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7011 7.11922C14.0916 7.50974 14.7248 7.50974 15.1153 7.11922C15.5058 6.72869 15.5058 6.09553 15.1153 5.705L11.1213 1.71102C10.7308 1.32049 10.0976 1.32049 9.7071 1.71102C9.31657 2.10154 9.31657 2.7347 9.7071 3.12523L13.7011 7.11922Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.7655C14.4153 10.1518 14 9.26279 14 8V12H15V10.7655ZM1 10.7655C1.58473 10.1518 2 9.26279 2 8V12H1V10.7655Z",
    fill: "currentColor"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03823 7.31894C2.37639 4.32591 4.91657 2 8 2C10.7676 2 13.0976 3.87386 13.7904 6.42207C15.1006 7.07898 16 8.43446 16 10C16 12.2091 14.2091 14 12 14H8H3.5C1.567 14 0 12.433 0 10.5C0 9.08881 0.835182 7.87268 2.03823 7.31894Z",
    fill: "currentColor"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud_from",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03823 7.31894C2.37639 4.32591 4.91657 2 8 2C10.7676 2 13.0976 3.87386 13.7904 6.42207C15.1006 7.07898 16 8.43446 16 10C16 12.2091 14.2091 14 12 14H8H3.5C1.567 14 0 12.433 0 10.5C0 9.08881 0.835182 7.87268 2.03823 7.31894Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5C7.44772 5 7 5.44772 7 6V8L5 8L8 12L11 8L9 8V6C9 5.44772 8.55228 5 8 5Z",
    fill: "currentColor"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud_to",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03823 7.31894C2.37639 4.32591 4.91657 2 8 2C10.7676 2 13.0976 3.87386 13.7904 6.42207C15.1006 7.07898 16 8.43446 16 10C16 12.2091 14.2091 14 12 14H8H3.5C1.567 14 0 12.433 0 10.5C0 9.08881 0.835182 7.87268 2.03823 7.31894Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12C8.55228 12 9 11.5523 9 11V9L11 9L8 5L5 9L7 9V11C7 11.5523 7.44772 12 8 12Z",
    fill: "currentColor"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "code",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.66667C2 2.29848 2.29848 2 2.66667 2H13.3333C13.7015 2 14 2.29848 14 2.66667V13.3333C14 13.7015 13.7015 14 13.3333 14H2.66667C2.29848 14 2 13.7015 2 13.3333V2.66667ZM7.13807 5.86193C7.39842 6.12228 7.39842 6.54439 7.13807 6.80474L5.94281 8L7.13807 9.19526C7.39842 9.45561 7.39842 9.87772 7.13807 10.1381C6.87772 10.3984 6.45561 10.3984 6.19526 10.1381L4.5286 8.4714C4.40357 8.34638 4.33333 8.17681 4.33333 8C4.33333 7.82319 4.40357 7.65362 4.5286 7.5286L6.19526 5.86193C6.45561 5.60158 6.87772 5.60158 7.13807 5.86193ZM9.80474 5.86193C9.54439 5.60158 9.12228 5.60158 8.86193 5.86193C8.60158 6.12228 8.60158 6.54439 8.86193 6.80474L10.0572 8L8.86193 9.19526C8.60158 9.45561 8.60158 9.87772 8.86193 10.1381C9.12228 10.3984 9.54439 10.3984 9.80474 10.1381L11.4714 8.4714C11.5964 8.34638 11.6667 8.17681 11.6667 8C11.6667 7.82319 11.5964 7.65362 11.4714 7.5286L9.80474 5.86193Z",
    fill: "currentColor"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "collection",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 16,
    height: 6,
    rx: 1.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.5,
    width: 12,
    height: 1.5,
    rx: 0.75,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 8,
    height: 1.5,
    rx: 0.75,
    fill: "currentColor"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "column_add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5V1H4L4 5L0 5ZM0 10V6H4L4 10H0ZM0 11V15H4L4 11H0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1V5L9 5L9 1H5ZM5 6V10H9L9 6H5ZM5 15V11H9L9 15H5ZM12 5H14V7H16V9H14V11H12V9H10V7H12V5Z",
    fill: "currentColor"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "columns_increasing",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10H2C1.44772 10 1 10.4477 1 11V15C1 15.5523 1.44772 16 2 16H4C4.55228 16 5 15.5523 5 15V11C5 10.4477 4.55228 10 4 10ZM9 5H7C6.44772 5 6 5.44772 6 6V15C6 15.5523 6.44772 16 7 16H9C9.55228 16 10 15.5523 10 15V6C10 5.44772 9.55228 5 9 5ZM14 0H12C11.4477 0 11 .44772 11 1V15C11 15.5523 11.4477 16 12 16H14C14.5523 16 15 15.5523 15 15V1C15 .44772 14.5523 0 14 0Z",
    fill: "currentColor"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "command",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.5V4.5C5.5 3.94772 5.05228 3.5 4.5 3.5C3.94772 3.5 3.5 3.94772 3.5 4.5C3.5 5.05228 3.94772 5.5 4.5 5.5H5.5ZM5.5 7H4.5C3.11929 7 2 5.88071 2 4.5C2 3.11929 3.11929 2 4.5 2C5.88071 2 7 3.11929 7 4.5V5.5H9V4.5C9 3.11929 10.1193 2 11.5 2C12.8807 2 14 3.11929 14 4.5C14 5.88071 12.8807 7 11.5 7H10.5V9H11.5C12.8807 9 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5V10.5H7V11.5C7 12.8807 5.88071 14 4.5 14C3.11929 14 2 12.8807 2 11.5C2 10.1193 3.11929 9 4.5 9H5.5V7ZM5.5 10.5H4.5C3.94772 10.5 3.5 10.9477 3.5 11.5C3.5 12.0523 3.94772 12.5 4.5 12.5C5.05228 12.5 5.5 12.0523 5.5 11.5V10.5ZM7 9V8.5V7.5V7H7.5H8.5H9V7.5V8.5V9H8.5H7.5H7ZM10.5 10.5V11.5C10.5 12.0523 10.9477 12.5 11.5 12.5C12.0523 12.5 12.5 12.0523 12.5 11.5C12.5 10.9477 12.0523 10.5 11.5 10.5H10.5ZM10.5 5.5H11.5C12.0523 5.5 12.5 5.05228 12.5 4.5C12.5 3.94772 12.0523 3.5 11.5 3.5C10.9477 3.5 10.5 3.94772 10.5 4.5V5.5Z",
    fill: "currentColor"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "comment",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33334 6C1.33334 3.79086 3.1242 2 5.33334 2H10.6667C12.8758 2 14.6667 3.79086 14.6667 6V10C14.6667 12.2091 12.8758 14 10.6667 14H2C1.63181 14 1.33334 13.7015 1.33334 13.3333V6ZM6 6C5.63181 6 5.33334 6.29848 5.33334 6.66667C5.33334 7.03486 5.63181 7.33333 6 7.33333H10C10.3682 7.33333 10.6667 7.03486 10.6667 6.66667C10.6667 6.29848 10.3682 6 10 6H6ZM6 8.66667C5.63181 8.66667 5.33334 8.96514 5.33334 9.33333C5.33334 9.70152 5.63181 10 6 10H8C8.36819 10 8.66667 9.70152 8.66667 9.33333C8.66667 8.96514 8.36819 8.66667 8 8.66667H6Z",
    fill: "currentColor"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "compare",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11 9 8 9 10 2 10 2 12 9 12 9 14 13 11ZM2 5 6 8 6 6 13 6 13 4 6 4 6 2 2 5Z",
    fill: "currentColor"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "compass",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32655 4.46256 2.90912 2.90918 4.46248 6.32658 5.8182 5.81818 6.32655 4.46256ZM4.46256 9.67344 2.90912 13.091 6.32663 11.5376 5.8182 10.1818 4.46256 9.67344ZM9.67339 11.5376 13.0909 13.091 11.5375 9.67343 10.1818 10.1818 9.67339 11.5376ZM11.5376 6.32659 13.0909 2.90918 9.67346 4.46257 10.1818 5.81818 11.5376 6.32659Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0L10.1818 5.81818L16 8L10.1818 10.1818L8 16L5.81818 10.1818L0 8L5.81818 5.81818L8 0ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    fill: "currentColor"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "compliance",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H14V4H2V2ZM2 5H14V5.22597C13.3469 5.0707 12.6308 5.24783 12.1213 5.75736L10.8786 7H2V5ZM9.87865 8H6.46613C6.97741 8.00043 7.48856 8.19569 7.87865 8.58579L8.58576 9.29289 9.87865 8ZM6.46274 8H2V10L3.63601 10 5.05022 8.58579C5.44032 8.19569 5.95146 8.00043 6.46274 8ZM3.09335 11H2V13H3.80758L3.63601 12.8284C3.13952 12.3319 2.95864 11.6394 3.09335 11ZM6.46445 10 5.05023 11.4142 8.58577 14.9497 9.99998 13.5355 6.46445 10ZM14.9497 8.58578 13.5355 7.17157 8.58577 12.1213 9.99999 13.5355 14.9497 8.58578Z",
    fill: "currentColor"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "compliance2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V6.80764L15.9497 6.75736C15.1687 5.97631 13.9023 5.97631 13.1213 6.75736L9.58576 10.2929L8.87865 9.58579C8.0976 8.80474 6.83127 8.80474 6.05022 9.58579L4.63601 11C3.85496 11.781 3.85496 13.0474 4.63601 13.8284L6.80758 16H2C0.895431 16 0 15.1046 0 14V2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H14V4H2V2ZM2 5H14V6.24423C13.6782 6.33333 13.3743 6.50437 13.1213 6.75736L12.8786 7H2V5ZM11.8786 8H2V10H5.63601L6.05022 9.58579C6.83127 8.80474 8.0976 8.80474 8.87865 9.58579L9.29286 10H9.87865L11.8786 8ZM4.63601 11 2 11V13H4.13752C3.92857 12.3156 4.09473 11.5413 4.63601 11ZM7.46445 11 6.05023 12.4142 9.58577 15.9497 11 14.5355 7.46445 11ZM15.9497 9.58578 14.5355 8.17157 9.58577 13.1213 11 14.5355 15.9497 9.58578Z",
    fill: "currentColor"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "connector",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C2.23858 3 0 5.23858 0 8C0 10.7614 2.23858 13 5 13H7V9H11C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7L7 7V3H5ZM6.99998 7V4.99999H4.99998C3.34313 4.99999 1.99998 6.34314 1.99998 7.99999C1.99998 9.65685 3.34313 11 4.99998 11H6.99998V9H5C4.44772 9 4 8.55228 4 8C4 7.44771 4.44772 7 5 7H6.99998ZM11 13C13.7614 13 16 10.7614 16 8C16 5.23858 13.7614 3 11 3H9V5L11 5C12.6569 5 14 6.34315 14 8C14 9.65685 12.6569 11 11 11H9V13H11Z",
    fill: "currentColor"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "connector_add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C2.23858 3 0 5.23858 0 8C0 10.7614 2.23858 13 5 13H7V9H9.99951C10.5797 8.56409 11.2578 8.25147 11.995 8.10105C11.9983 8.06782 12 8.03411 12 8C12 7.44772 11.5523 7 11 7L7 7V3H5ZM16 8C16 8.31972 15.97 8.63244 15.9126 8.93548C15.3505 8.53193 14.7012 8.24211 13.9984 8.09969C13.9995 8.06659 14 8.03336 14 8C14 6.34315 12.6569 5 11 5L9 5V3H11C13.7614 3 16 5.23858 16 8ZM6.99998 7V4.99999H4.99998C3.34313 4.99999 1.99998 6.34314 1.99998 7.99999C1.99998 9.65685 3.34313 11 4.99998 11H6.99998V9H5C4.44772 9 4 8.55228 4 8C4 7.44771 4.44772 7 5 7H6.99998ZM12 10H14V12H16V14H14V16H12V14H10V12H12V10Z",
    fill: "currentColor"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "convert",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9L0 6L4 3L4 5L11 5V7L4 7V9ZM12 6L16 9L12 12V10H5V8H12V6Z",
    fill: "currentColor"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    y: 4,
    width: 12,
    height: 12,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 10,
    height: 10,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "copy2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10V14H2V6H6M6 10H14V2H6V10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "copy_as_path",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2 8 14H10L14 2H12ZM8 2 4 14H6L10 2H8ZM4 5H2V7H4V5ZM4 10H2V12H4V10Z",
    fill: "currentColor"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "create_account",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6V8M12 8V10M12 8H14M12 8H10M8.66667 4.66667C8.66667 5.37391 8.38572 6.05219 7.88562 6.55229C7.38552 7.05238 6.70724 7.33333 6 7.33333C5.29276 7.33333 4.61448 7.05238 4.11438 6.55229C3.61428 6.05219 3.33333 5.37391 3.33333 4.66667C3.33333 3.95942 3.61428 3.28115 4.11438 2.78105C4.61448 2.28095 5.29276 2 6 2C6.70724 2 7.38552 2.28095 7.88562 2.78105C8.38572 3.28115 8.66667 3.95942 8.66667 4.66667ZM2 13.3333C2 12.2725 2.42143 11.2551 3.17157 10.5049C3.92172 9.75476 4.93913 9.33333 6 9.33333C7.06087 9.33333 8.07828 9.75476 8.82843 10.5049C9.57857 11.2551 10 12.2725 10 13.3333V14H2V13.3333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "credit_card",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 3.89543 0.895431 3 2 3H14C15.1046 3 16 3.89543 16 5L0 5ZM0 7H16V11C16 12.1046 15.1046 13 14 13H2C0.895431 13 0 12.1046 0 11V7ZM14 9H11V10H14V9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    y: 5,
    width: 16,
    height: 2,
    fill: "currentColor"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "data_download",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 14,
    width: 10,
    height: 12,
    rx: 2,
    transform: "rotate(90 14 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16L11 12L9 12L9 5L7 5L7 12L5 12L8 16Z",
    fill: "currentColor"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "data_input",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 5,
    y: 2,
    width: 11,
    height: 12,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8L8 5V7L1 7L1 9H8V11L12 8Z",
    fill: "currentColor"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "data_output",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    y: 2,
    width: 10,
    height: 12,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8L12 5V7L5 7L5 9H12V11L16 8Z",
    fill: "currentColor"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "data_upload",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 2,
    y: 11,
    width: 11,
    height: 12,
    rx: 2,
    transform: "rotate(-90 2 11)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 7,
    y: 15,
    width: 4,
    height: 2,
    transform: "rotate(-90 7 15)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4L5 8L7 8L7 15L9 15L9 8L11 8L8 4Z",
    fill: "currentColor"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "datetime",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00001 9.33334C6.00001 6.75601 8.08935 4.66667 10.6667 4.66667C13.244 4.66667 15.3333 6.75601 15.3333 9.33334C15.3333 11.9107 13.244 14 10.6667 14C8.08935 14 6.00001 11.9107 6.00001 9.33334ZM10.6667 7.33334C11.0349 7.33334 11.3333 7.63181 11.3333 8V9.0572L12.2492 9.97304C12.5095 10.2334 12.5095 10.6555 12.2492 10.9159C11.9888 11.1762 11.5667 11.1762 11.3064 10.9159L10.1953 9.80474C10.0703 9.67972 10 9.51015 10 9.33334V8C10 7.63181 10.2985 7.33334 10.6667 7.33334Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.71474 4.26235C.6508 3.89975.89292 3.55398 1.25551 3.49004L9.79051 1.98509C10.1531 1.92116 10.4989 2.16327 10.5628 2.52587L10.7052 3.33346C10.6924 3.33338 10.6795 3.33334 10.6667 3.33334 8.89333 3.33334 7.29967 4.10267 6.20124 5.32578L1.06203 6.23196.71474 4.26235ZM5.2003 6.85618 1.29357 7.54504 2.10392 12.1408C2.16786 12.5034 2.51363 12.7455 2.87623 12.6816L5.41329 12.2342C4.93752 11.3745 4.66668 10.3855 4.66668 9.33334 4.66668 8.45004 4.85755 7.61132 5.2003 6.85618Z",
    fill: "currentColor"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "default_user",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2 14.4C1.85675 13.3926 0.864533 11.988 0.363892 10.3853C-0.13675 8.78266 -0.120432 7.06307 0.410534 5.47018C0.941499 3.87728 1.96019 2.49183 3.32232 1.51006C4.68444 0.528299 6.32094 0 8 0C9.67906 0 11.3156 0.528299 12.6777 1.51006C14.0398 2.49183 15.0585 3.87728 15.5895 5.47018C16.1204 7.06307 16.1367 8.78266 15.6361 10.3853C15.1355 11.988 14.1432 13.3926 12.8 14.4C12.6988 13.4991 12.3445 12.6453 11.7782 11.9374C11.2119 11.2296 10.4567 10.6965 9.6 10.4C10.2391 10.0231 10.7392 9.44973 11.0257 8.76536C11.3123 8.08098 11.3699 7.32231 11.1899 6.60252C11.01 5.88273 10.6021 5.24042 10.0273 4.77139C9.45237 4.30237 8.74126 4.03178 8 4C7.25874 4.03178 6.54763 4.30237 5.97274 4.77139C5.39786 5.24042 4.99002 5.88273 4.81008 6.60252C4.63013 7.32231 4.68772 8.08098 4.97425 8.76536C5.26079 9.44973 5.76091 10.0231 6.4 10.4C5.54332 10.6965 4.78812 11.2296 4.22181 11.9374C3.6555 12.6453 3.30123 13.4991 3.2 14.4Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "docs",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04419 0.95581H14.0442V2.95581H2.04419V0.95581ZM2.04419 4.95581H10.0442V6.95581H2.04419V4.95581ZM12.0442 8.95581H4.04419V10.9558H12.0442V8.95581ZM2.04419 12.9558H14.0442V14.9558H2.04419V12.9558Z",
    fill: "currentColor"
  })))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "document",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66666 2.33333V4.66667C8.66666 5.40305 9.2636 6 10 6H12.3333M5.99999 8.66667H8M5.99999 11.3333H10.3333M5.33333 2H8.1144C8.468 2 8.80713 2.14047 9.0572 2.39053L12.2761 5.60947C12.5262 5.85953 12.6667 6.19866 12.6667 6.55229V12C12.6667 13.1046 11.7713 14 10.6667 14H5.33333C4.22876 14 3.33333 13.1046 3.33333 12V4C3.33333 2.89543 4.22876 2 5.33333 2Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "drive",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.5V13.5C0 14.8807 3.58172 16 8 16C12.4183 16 16 14.8807 16 13.5V9.5C16 10.8807 12.4183 12 8 12C3.58172 12 0 10.8807 0 9.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4V8C0 9.38071 3.58172 10.5 8 10.5C12.4183 10.5 16 9.38071 16 8V4C16 5.38071 12.4183 6.5 8 6.5C3.58172 6.5 0 5.38071 0 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 2.5,
    rx: 8,
    ry: 2.5,
    fill: "currentColor"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "drop_files",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08447 8.30057C3.03159 7.98577 3.27426 7.69892 3.59347 7.69892H12.4065C12.7258 7.69892 12.9684 7.98577 12.9155 8.30057L12.2146 12.4726C12.1729 12.7212 11.9577 12.9032 11.7056 12.9032H4.29437C4.04232 12.9032 3.82714 12.7212 3.78538 12.4726L3.08447 8.30057Z",
    fill: "currentColor",
    fillOpacity: 0.3,
    stroke: "currentColor",
    strokeWidth: 0.172043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55914 3.01075C4.55914 2.91573 4.63617 2.83871 4.73119 2.83871H10.33L11.4409 3.94961V5.24731V7.69892H4.55914V3.01075Z",
    stroke: "currentColor",
    strokeWidth: 0.172043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78494 5.07527C3.78494 4.79022 4.01602 4.55914 4.30107 4.55914H4.55914V7.69892H3.78494V5.07527Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.172043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2151 5.76344C12.2151 5.47839 11.984 5.24731 11.6989 5.24731H11.4409V7.65591H12.2151V5.76344Z",
    fill: "currentColor",
    fillOpacity: 0.8,
    stroke: "currentColor",
    strokeWidth: 0.172043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.54839V10.9247M7.31183 10.2366H8.68817M8 3.74194V6.32258M8 6.32258 8.90322 5.46237M8 6.32258 7.09677 5.46237",
    stroke: "currentColor",
    strokeWidth: 0.172043,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 15.914C12.3708 15.914 15.914 12.3708 15.914 8C15.914 3.62923 12.3708 0.0860214 8.00001 0.0860214C3.62924 0.0860214 0.0860291 3.62923 0.0860291 8C0.0860291 12.3708 3.62924 15.914 8.00001 15.914Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 0.172043,
    strokeDasharray: "0.34 0.34"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "duplicate",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4H2C0.895431 4 0 4.89543 0 6V14C0 15.1046 0.895431 16 2 16H10C11.1046 16 12 15.1046 12 14V12H6C4.89543 12 4 11.1046 4 10V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 12,
    height: 12,
    rx: 2,
    fill: "currentColor"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5286 1.5286C10.789 1.26825 11.2111 1.26825 11.4714 1.5286L14.4714 4.5286C14.7318 4.78895 14.7318 5.21106 14.4714 5.47141L5.47141 14.4714C5.34639 14.5964 5.17682 14.6667 5.00001 14.6667H2.00001C1.63182 14.6667 1.33334 14.3682 1.33334 14V11C1.33334 10.8232 1.40358 10.6536 1.52861 10.5286L10.5286 1.5286ZM9.33334 13.3333C8.96515 13.3333 8.66668 13.6318 8.66668 14 8.66668 14.3682 8.96515 14.6667 9.33334 14.6667H14C14.3682 14.6667 14.6667 14.3682 14.6667 14 14.6667 13.6318 14.3682 13.3333 14 13.3333H9.33334Z",
    fill: "currentColor"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "enso_logo",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.62 10.8111C11.9646 10.4101 12.1729 9.88852 12.1729 9.31827C12.1729 8.05262 11.1469 7.0266 9.88125 7.0266C9.09091 7.0266 8.39401 7.42669 7.98204 8.03539C7.39794 8.82865 6.45749 9.34335 5.39683 9.34335C4.674 9.34335 4.007 9.10431 3.47057 8.70097L3.47073 8.70195C3.58179 9.41859 3.86131 10.0986 4.28633 10.6862C4.71135 11.2738 5.26973 11.7522 5.91558 12.0819C6.56143 12.4117 7.27633 12.5836 8.00151 12.5833C8.7267 12.5831 9.44148 12.4108 10.0871 12.0806C10.6855 11.7745 11.2086 11.3409 11.62 10.8111Z",
    fill: "currentColor"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "enter_node",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8L1 8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6L10 8L7 10L7 6Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "error",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2167 2H5.78999C5.61666 2 5.44333 2.07333 5.32333 2.19333L2.19666 5.32C2.07666 5.44 2.00333 5.61333 2.00333 5.78667V10.2067C2.00333 10.3867 2.07666 10.5533 2.19666 10.68L5.31666 13.8C5.44333 13.9267 5.61666 14 5.78999 14H10.21C10.39 14 10.5567 13.9267 10.6833 13.8067L13.8033 10.6867C13.93 10.56 13.9967 10.3933 13.9967 10.2133V5.78667C13.9967 5.60667 13.9233 5.44 13.8033 5.31333L10.6833 2.19333C10.5633 2.07333 10.39 2 10.2167 2ZM8.00333 11.5333C7.52333 11.5333 7.13666 11.1467 7.13666 10.6667C7.13666 10.1867 7.52333 9.8 8.00333 9.8C8.48333 9.8 8.86999 10.1867 8.86999 10.6667C8.86999 11.1467 8.48333 11.5333 8.00333 11.5333ZM8.00333 8.66667C7.63666 8.66667 7.33666 8.36667 7.33666 8V5.33333C7.33666 4.96667 7.63666 4.66667 8.00333 4.66667C8.36999 4.66667 8.66999 4.96667 8.66999 5.33333V8C8.66999 8.36667 8.36999 8.66667 8.00333 8.66667Z",
    fill: "currentColor"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1H7.5C6.94772 1 6.5 1.44772 6.5 2V10C6.5 10.5523 6.94772 11 7.5 11H8.5C9.05228 11 9.5 10.5523 9.5 10V2C9.5 1.44772 9.05228 1 8.5 1ZM8.5 12H7.5C6.94772 12 6.5 12.4477 6.5 13V14C6.5 14.5523 6.94772 15 7.5 15H8.5C9.05228 15 9.5 14.5523 9.5 14V13C9.5 12.4477 9.05228 12 8.5 12Z",
    fill: "currentColor"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "exit_fullscreen",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.70767 1.30888 5.28015 3.88136 5.28015 1.29553H7.28015V6.29553C7.28015 6.84782 6.83244 7.29553 6.28015 7.29553H1.28015V5.29553H3.8659L1.29346 2.72309C.90294 2.33257.90294 1.69941 1.29346 1.30888 1.68398.91836 2.31715.91836 2.70767 1.30888ZM2.70711 15.2827 5.28015 12.7097 5.28015 15.2955H7.28015V10.2955C7.28015 9.74325 6.83244 9.29553 6.28015 9.29553H1.28015V11.2955H3.86591L1.29289 13.8685C.90237 14.259.90237 14.8922 1.29289 15.2827 1.68342 15.6733 2.31658 15.6733 2.70711 15.2827ZM15.2793 13.8805 12.6944 11.2955H15.2802V9.29553H10.2802C9.72787 9.29553 9.28015 9.74324 9.28015 10.2955V15.2955H11.2802L11.2802 12.7098 13.8651 15.2947C14.2556 15.6852 14.8888 15.6852 15.2793 15.2947 15.6698 14.9041 15.6698 14.271 15.2793 13.8805ZM13.8686 1.29289 11.2802 3.88129 11.2802 1.29553H9.28015V6.29553C9.28015 6.84782 9.72786 7.29553 10.2802 7.29553H15.2802V5.29553H12.6944L15.2828 2.7071C15.6733 2.31658 15.6733 1.68342 15.2828 1.29289 14.8923.90237 14.2591.90237 13.8686 1.29289Z",
    fill: "currentColor"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "expanded_node",
    viewBox: "0 0 16 14",
    width: 16,
    height: 14,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 2C0 0.89543 0.895431 0 2 0H14C15.1046 0 16 0.89543 16 2V4H0V2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 5H16V12C16 13.1046 15.1046 14 14 14H2C0.895431 14 0 13.1046 0 12V5Z",
    fill: "currentColor"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C14 5.25 11.5 2.5 8 2.5C4.5 2.5 2 5.25 0 8C2 10.75 4.5 13.5 8 13.5C11.5 13.5 14 10.75 16 8ZM5.5 8C5.5 9.38071 6.61929 10.5 8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8Z",
    fill: "currentColor"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye_crossed",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_216)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C14 5.25 11.5 2.5 8 2.5C4.5 2.5 2 5.25 2.38817e-06 8C2 10.75 4.5 13.5 8 13.5C11.5 13.5 14 10.75 16 8ZM8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.655 0.924972L0.927108 13.6529C0.536584 14.0434 0.536584 14.6766 0.927108 15.0671C1.31763 15.4576 1.9508 15.4576 2.34132 15.0671L15.0692 2.33919C15.4598 1.94866 15.4598 1.3155 15.0692 0.924972C14.6787 0.534448 14.0456 0.534448 13.655 0.924972Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "find",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6.5C11 8.98528 8.98528 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5ZM9.91218 12.0334C8.9204 12.6463 7.7515 13 6.5 13C2.91015 13 0 10.0899 0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5C13 7.75147 12.6463 8.92033 12.0335 9.91209L15.5601 13.4387C16.1458 14.0244 16.1458 14.9742 15.5601 15.56C14.9743 16.1458 14.0245 16.1458 13.4387 15.56L9.91218 12.0334Z",
    fill: "currentColor"
  })))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C0.895431 1 0 1.89543 0 3V6H16V5C16 3.89543 15.1046 3 14 3H8C8 1.89543 7.10457 1 6 1H2ZM0 13V7H16V13C16 14.1046 15.1046 15 14 15H2C0.89543 15 0 14.1046 0 13Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "folder_add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_968_255",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_968_255)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.89543 0.895431 1 2 1H6C7.10457 1 8 1.89543 8 3H14C15.1046 3 16 3.89543 16 5V5.67363C18.3649 6.79709 20 9.2076 20 12C20 15.866 16.866 19 13 19C10.2076 19 7.79709 17.3649 6.67363 15H2C0.89543 15 0 14.1046 0 13V7H8.10102C8.49 6.61882 8.92328 6.28268 9.39241 6H0V3ZM13 17C11.3642 17 9.91184 16.2144 8.99963 15C8.37194 14.1643 8 13.1256 8 12C8 9.23858 10.2386 7 13 7C14.1256 7 15.1643 7.37194 16 7.99963C17.2144 8.91184 18 10.3642 18 12C18 14.7614 15.7614 17 13 17ZM14 14V13H16V11H14V9H12V11H10V13H12V14V15H14V14Z",
    fill: "currentColor"
  })))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_add_small",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.66667C12.3682 8.66667 12.6667 8.96513 12.6667 9.33333V10.6667H14C14.3682 10.6667 14.6667 10.9651 14.6667 11.3333C14.6667 11.7015 14.3682 12 14 12H12.6667V13.3333C12.6667 13.7015 12.3682 14 12 14C11.6318 14 11.3333 13.7015 11.3333 13.3333V12H10C9.63181 12 9.33334 11.7015 9.33334 11.3333C9.33334 10.9651 9.63181 10.6667 10 10.6667H11.3333V9.33333C11.3333 8.96513 11.6318 8.66667 12 8.66667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82162 2C6.57246 2 7.27361 2.37525 7.69014 3C8.10661 3.62475 8.80781 4 9.55868 4H12C13.4727 4 14.6667 5.19391 14.6667 6.66667V8.35187C13.959 7.71847 13.0245 7.33333 12 7.33333C9.79088 7.33333 8.00001 9.1242 8.00001 11.3333C8.00001 12.0619 8.19481 12.745 8.53514 13.3333H4.00001C2.52725 13.3333 1.33334 12.1394 1.33334 10.6667V4.66667C1.33334 3.19391 2.52725 2 4.00001 2H5.82162Z",
    fill: "currentColor"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_closed",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58579 3.75735L8.82843 7.99999L4.58579 12.2426L6 13.6568L10.2426 9.41421L11.6569 7.99999L10.2426 6.58578L6 2.34314L4.58579 3.75735Z",
    fill: "currentColor"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_opened",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2426 4.58579L8.00001 8.82843L3.75737 4.58579L2.34315 6L6.58579 10.2426L8.00001 11.6569L9.41422 10.2426L13.6569 6L12.2426 4.58579Z",
    fill: "currentColor"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder_small",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 4.66667C1.33334 3.19391 2.52725 2 4.00001 2H5.83825C6.5455 2 7.22374 2.28095 7.72388 2.78105L7.88561 2.94281C8.13568 3.19286 8.47481 3.33333 8.82841 3.33333H12C13.4727 3.33333 14.6667 4.52724 14.6667 6V6.66642C14.1095 6.24796 13.4171 6 12.6667 6H3.33334C2.58294 6 1.89045 6.24796 1.33334 6.66642V4.66667ZM1.33334 9.33333V10.6667C1.33334 12.1394 2.52725 13.3333 4.00001 13.3333H12C13.4727 13.3333 14.6667 12.1394 14.6667 10.6667V9.33333C14.6667 8.22873 13.7713 7.33333 12.6667 7.33333H3.33334C2.22878 7.33333 1.33334 8.22873 1.33334 9.33333Z",
    fill: "currentColor"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "fullscreen",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H2C0.895431 0 0 0.895431 0 2V6H2V3.4142L4.55382 5.96802C4.89799 5.38559 5.3856 4.89798 5.96804 4.55381L3.41423 2H6V0ZM10.032 4.55381C10.6144 4.89798 11.102 5.38559 11.4462 5.96802L14 3.4142V6H16V2C16 0.895431 15.1046 0 14 0H10V2H12.5858L10.032 4.55381ZM11.4462 10.032C11.102 10.6144 10.6144 11.102 10.032 11.4462L12.5858 14H10V16H14C15.1046 16 16 15.1046 16 14V10H14V12.5858L11.4462 10.032ZM5.96802 11.4462C5.38559 11.102 4.89798 10.6144 4.55381 10.032L2 12.5858V10H0V14C0 15.1046 0.895431 16 2 16H6V14H3.4142L5.96802 11.4462Z",
    fill: "currentColor"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "fullscreen2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1716 6.99999L11.2929 6.12132L12.7071 4.70711L14.5858 6.58579L16 8L14.5858 9.41421L12.7071 11.2929L11.2929 9.87868L12.1716 8.99999H8.99997V12.1716L9.87868 11.2929L11.2929 12.7071L9.41421 14.5858L8 16L6.58579 14.5858L4.70711 12.7071L6.12132 11.2929L6.99997 12.1715V8.99999H3.82842L4.70711 9.87868L3.29289 11.2929L1.41421 9.41421L-9.53674e-07 8L1.41421 6.58579L3.29289 4.70711L4.70711 6.12132L3.82843 6.99999H6.99997V3.82845L6.12132 4.70711L4.70711 3.29289L6.58579 1.41421L8 0L9.41421 1.41421L11.2929 3.29289L9.87868 4.70711L8.99997 3.8284V6.99999L12.1716 6.99999Z",
    fill: "currentColor"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "fullscreen3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4L8 0L11 4H8.99997V6H6.99997V4H5ZM4 9V11L0 8L4 5V7H6V9H4ZM8.99997 12H11L8 16L5 12H6.99997V10H8.99997V12ZM16 8L12 11V9H10V7H12V5L16 8Z",
    fill: "currentColor"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "geo_map_distance",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3H1V13H3V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6 7H4V13H6V7ZM9 7H7V13H9V7ZM15 7H13V13H15V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3H10V13H12V3Z",
    fill: "currentColor"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "geo_map_pin",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2426 11.2426C13.0818 10.4035 13.6532 9.33443 13.8847 8.17054C14.1162 7.00665 13.9974 5.80025 13.5433 4.7039C13.0892 3.60754 12.3201 2.67047 11.3334 2.01118C10.3467 1.35189 9.18669 1 8 1C6.81331 1 5.65328 1.35189 4.66658 2.01118C3.67989 2.67047 2.91085 3.60754 2.45673 4.7039C2.0026 5.80025 1.88378 7.00665 2.11529 8.17054C2.3468 9.33443 2.91825 10.4035 3.75736 11.2426L3.76 11.24L8 15.48L12.24 11.24L12.2426 11.2426ZM8 9.5C9.38071 9.5 10.5 8.38071 10.5 7C10.5 5.61929 9.38071 4.5 8 4.5C6.61929 4.5 5.5 5.61929 5.5 7C5.5 8.38071 6.61929 9.5 8 9.5Z",
    fill: "currentColor"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "ghost",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.5C14 3.18629 11.3137 0.5 8 0.5C4.68629 0.5 2 3.18629 2 6.5V15.5C2 15.5 2.75 14.25 4.5 14.25C5.4159 14.25 5.93424 14.5924 6.42835 14.9188C6.87833 15.216 7.30822 15.5 8 15.5C8.69178 15.5 9.12167 15.216 9.57165 14.9188C10.0658 14.5924 10.5841 14.25 11.5 14.25C13.25 14.25 14 15.5 14 15.5V6.5ZM7 6.5C7 7.32843 6.32843 8 5.5 8C4.67157 8 4 7.32843 4 6.5C4 5.67157 4.67157 5 5.5 5C6.32843 5 7 5.67157 7 6.5ZM10.5 8C11.3284 8 12 7.32843 12 6.5C12 5.67157 11.3284 5 10.5 5C9.67157 5 9 5.67157 9 6.5C9 7.32843 9.67157 8 10.5 8Z",
    fill: "currentColor"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "github_color",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_213)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.976 0C3.566 0 0 3.592 0 8.035C0 11.587 2.285 14.594 5.454 15.658C5.85 15.738 5.995 15.485 5.995 15.272C5.995 15.086 5.982 14.447 5.982 13.782C3.763 14.261 3.301 12.824 3.301 12.824C2.944 11.893 2.416 11.653 2.416 11.653C1.69 11.161 2.469 11.161 2.469 11.161C3.275 11.214 3.697 11.986 3.697 11.986C4.41 13.21 5.559 12.864 6.021 12.651C6.087 12.132 6.298 11.773 6.523 11.573C4.753 11.387 2.891 10.695 2.891 7.608C2.891 6.73 3.208 6.012 3.71 5.453C3.631 5.253 3.353 4.429 3.789 3.324C3.789 3.324 4.462 3.111 5.981 4.149C6.6311 3.97317 7.30154 3.88373 7.975 3.883C8.648 3.883 9.335 3.976 9.969 4.149C11.488 3.111 12.161 3.324 12.161 3.324C12.597 4.428 12.319 5.253 12.24 5.453C12.755 6.012 13.059 6.73 13.059 7.608C13.059 10.695 11.197 11.373 9.414 11.573C9.705 11.826 9.955 12.305 9.955 13.063C9.955 14.141 9.942 15.005 9.942 15.271C9.942 15.484 10.087 15.737 10.483 15.657C13.652 14.593 15.937 11.586 15.937 8.034C15.952 3.592 12.374 0 7.976 0Z",
    fill: "#171515"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "google_color",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66636 15.8245C10.9925 15.5421 12.2172 14.9291 13.2316 14.0523L10.6177 12.0013C10.127 12.3224 9.57781 12.5527 8.99597 12.6766C7.92483 12.9048 6.80784 12.7583 5.83175 12.2616C4.85566 11.765 4.07963 10.9484 3.6334 9.94824C3.57221 9.81108 3.51772 9.6716 3.46999 9.5303L0.842987 11.5745C1.60697 13.1043 2.84283 14.352 4.37227 15.1302C6.00537 15.9611 7.87422 16.2062 9.66636 15.8245Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46999 9.53031L0.842985 11.5745C0.7912 11.4708 0.741583 11.3658 0.69419 11.2596C-0.0523962 9.58629 -0.201934 7.70738 0.270576 5.93702C0.410984 5.41095 0.603788 4.90395 0.844315 4.42282L3.46958 6.4709C3.43669 6.56836 3.40687 6.6671 3.38021 6.76698C3.13653 7.67999 3.16965 8.64131 3.46999 9.53031Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29013 1.53339C2.24912 2.2916 1.41323 3.28482 0.844315 4.42282L3.46958 6.4709C3.78512 5.53597 4.38328 4.71888 5.18496 4.13498C6.07021 3.49022 7.14997 3.16889 8.24371 3.22471C9.33745 3.28053 10.3789 3.71011 11.1939 4.44165L13.3437 2.04647C11.9801 0.822539 10.2377 0.103794 8.40775 0.0104031C6.5778 -0.0829874 4.77125 0.454637 3.29013 1.53339Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.50002H16V8H16C16 9.83233 15.371 11.6091 14.2182 13.0333C13.9184 13.4036 13.588 13.7443 13.2316 14.0523L10.6177 12.0013C11.0304 11.7313 11.4018 11.3972 11.7165 11.0084C12.0481 10.5988 12.3071 10.1404 12.4867 9.653C12.4932 9.63537 12.4996 9.61771 12.5059 9.60002H8V8.00002V6.50002Z",
    fill: "#4285F4"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "grab",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33334 2.66666H6.66667V3.99999H5.33334V2.66666ZM5.33334 7.33332H6.66667V8.66666H5.33334V7.33332ZM6.66667 12H5.33334V13.3333H6.66667V12ZM9.33334 2.66666H10.6667V3.99999H9.33334V2.66666ZM10.6667 7.33332H9.33334V8.66666H10.6667V7.33332ZM9.33334 12H10.6667V13.3333H9.33334V12Z",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "graph",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 4,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 16,
    height: 4,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.006 6C10.906 6 11.348 7.09595 10.6997 7.72027L8.69786 9.64825C8.3106 10.0212 7.69774 10.0212 7.31047 9.64825L5.30862 7.72027C4.66038 7.09595 5.10231 6 6.00231 6L10.006 6Z",
    fill: "currentColor"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "graph2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "graph_add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0H0V4H2.5V6H0V10H2.5V12H0V16H8.99963C8.37194 15.1643 8 14.1256 8 13C8 12.6575 8.03443 12.3231 8.10002 12H4.5V10H7V6H4.5V4H11.5V6H9V9.99951C9.91223 8.78534 11.3644 8 13 8C14.1256 8 15.1643 8.37194 16 8.99963V6H13.5V4H16V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14V15V16H12V15V14H10V12H12V10H14V12H16V14H14Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "group",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9714 2.02861C14.2318 2.28896 14.2318 2.71107 13.9714 2.97141L10.9428 6.00001H13.3333C13.7015 6.00001 14 6.29849 14 6.66668C14 7.03487 13.7015 7.33334 13.3333 7.33334H9.33334C8.96515 7.33334 8.66668 7.03487 8.66668 6.66668V2.66668C8.66668 2.29849 8.96515 2.00001 9.33334 2.00001C9.70153 2.00001 10 2.29849 10 2.66668V5.0572L13.0286 2.02861C13.289 1.76826 13.7111 1.76826 13.9714 2.02861ZM2.00001 9.33334C2.00001 8.96515 2.29849 8.66668 2.66668 8.66668H6.66668C7.03487 8.66668 7.33334 8.96515 7.33334 9.33334V13.3333C7.33334 13.7015 7.03487 14 6.66668 14C6.29849 14 6.00001 13.7015 6.00001 13.3333V10.9428L2.97141 13.9714C2.71107 14.2318 2.28896 14.2318 2.02861 13.9714C1.76826 13.7111 1.76826 13.289 2.02861 13.0286L5.0572 10H2.66668C2.29849 10 2.00001 9.70153 2.00001 9.33334Z",
    fill: "currentColor"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "header1",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.66667C2.36819 2.66667 2.66667 2.96514 2.66667 3.33333V7.33333H8V3.33333C8 2.96514 8.29848 2.66667 8.66667 2.66667C9.03486 2.66667 9.33334 2.96514 9.33334 3.33333V12.6667C9.33334 13.0349 9.03486 13.3333 8.66667 13.3333C8.29848 13.3333 8 13.0349 8 12.6667V8.66667H2.66667V12.6667C2.66667 13.0349 2.36819 13.3333 2 13.3333C1.63181 13.3333 1.33334 13.0349 1.33334 12.6667V3.33333C1.33334 2.96514 1.63181 2.66667 2 2.66667ZM14.2828 6.72961C14.517 6.83933 14.6667 7.07466 14.6667 7.33333V12.6667C14.6667 13.0349 14.3682 13.3333 14 13.3333C13.6318 13.3333 13.3333 13.0349 13.3333 12.6667V8.7567L12.4268 9.51215C12.1439 9.74786 11.7236 9.70964 11.4879 9.42679C11.2521 9.14394 11.2904 8.72356 11.5732 8.48785L13.5732 6.82119C13.7719 6.65559 14.0485 6.61989 14.2828 6.72961Z",
    fill: "currentColor"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "header2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99999 2.66667C2.36818 2.66667 2.66666 2.96514 2.66666 3.33333V7.33333H8V3.33333C8 2.96514 8.29847 2.66667 8.66666 2.66667C9.03485 2.66667 9.33333 2.96514 9.33333 3.33333V12.6667C9.33333 13.0349 9.03485 13.3333 8.66666 13.3333C8.29847 13.3333 8 13.0349 8 12.6667V8.66667H2.66666V12.6667C2.66666 13.0349 2.36818 13.3333 1.99999 13.3333C1.63181 13.3333 1.33333 13.0349 1.33333 12.6667V3.33333C1.33333 2.96514 1.63181 2.66667 1.99999 2.66667ZM13.3333 8C13.0874 8 12.8717 8.13281 12.7554 8.33382C12.5711 8.65253 12.1633 8.76143 11.8446 8.57707C11.5258 8.39271 11.4169 7.98489 11.6013 7.66618C11.9461 7.07012 12.5922 6.66667 13.3333 6.66667C14.4379 6.66667 15.3333 7.5621 15.3333 8.66667V8.8264C15.3333 9.30903 15.1588 9.77512 14.8424 10.1389L13.3748 12H14.6667C15.0349 12 15.3333 12.2985 15.3333 12.6667C15.3333 13.0349 15.0349 13.3333 14.6667 13.3333H12C11.7446 13.3333 11.5116 13.1874 11.4001 12.9576C11.2887 12.7277 11.3184 12.4544 11.4765 12.2539L13.8064 9.29941C13.8145 9.28913 13.8229 9.27909 13.8316 9.26931C13.9401 9.14728 14 8.98968 14 8.8264V8.66667C14 8.29848 13.7015 8 13.3333 8Z",
    fill: "currentColor"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "header3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99999 2.66667C2.36818 2.66667 2.66666 2.96514 2.66666 3.33333V7.33333H8V3.33333C8 2.96514 8.29847 2.66667 8.66666 2.66667C9.03485 2.66667 9.33333 2.96514 9.33333 3.33333V12.6667C9.33333 13.0349 9.03485 13.3333 8.66666 13.3333C8.29847 13.3333 8 13.0349 8 12.6667V8.66667H2.66666V12.6667C2.66666 13.0349 2.36818 13.3333 1.99999 13.3333C1.63181 13.3333 1.33333 13.0349 1.33333 12.6667V3.33333C1.33333 2.96514 1.63181 2.66667 1.99999 2.66667ZM13.3333 8C13.0874 8 12.8717 8.13281 12.7554 8.33382C12.5711 8.65253 12.1633 8.76143 11.8446 8.57707C11.5258 8.39271 11.4169 7.98489 11.6013 7.66618C11.9461 7.07012 12.5922 6.66667 13.3333 6.66667C14.4379 6.66667 15.3333 7.5621 15.3333 8.66667C15.3333 9.1789 15.1408 9.64616 14.8241 10C15.1408 10.3538 15.3333 10.8211 15.3333 11.3333C15.3333 12.4379 14.4379 13.3333 13.3333 13.3333C12.5922 13.3333 11.9461 12.9299 11.6013 12.3338C11.4169 12.0151 11.5258 11.6073 11.8446 11.4229C12.1633 11.2386 12.5711 11.3475 12.7554 11.6662C12.8717 11.8672 13.0874 12 13.3333 12C13.7015 12 14 11.7015 14 11.3333C14 10.9651 13.7015 10.6667 13.3333 10.6667C12.9651 10.6667 12.6667 10.3682 12.6667 10C12.6667 9.63181 12.9651 9.33333 13.3333 9.33333C13.7015 9.33333 14 9.03486 14 8.66667C14 8.29848 13.7015 8 13.3333 8Z",
    fill: "currentColor"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "heatmap",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.25 0.75H6.75C6.19772 0.75 5.75 1.19772 5.75 1.75V4.25C5.75 4.80228 6.19772 5.25 6.75 5.25H9.25C9.80228 5.25 10.25 4.80228 10.25 4.25V1.75C10.25 1.19772 9.80228 0.75 9.25 0.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M4.25 10.75H1.75C1.19772 10.75.75 11.1977.75 11.75V14.25C.75 14.8023 1.19772 15.25 1.75 15.25H4.25C4.80228 15.25 5.25 14.8023 5.25 14.25V11.75C5.25 11.1977 4.80228 10.75 4.25 10.75ZM14.25 5.75H11.75C11.1977 5.75 10.75 6.19772 10.75 6.75V9.25C10.75 9.80228 11.1977 10.25 11.75 10.25H14.25C14.8023 10.25 15.25 9.80228 15.25 9.25V6.75C15.25 6.19772 14.8023 5.75 14.25 5.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.25 10.75H6.75C6.19772 10.75 5.75 11.1977 5.75 11.75V14.25C5.75 14.8023 6.19772 15.25 6.75 15.25H9.25C9.80228 15.25 10.25 14.8023 10.25 14.25V11.75C10.25 11.1977 9.80228 10.75 9.25 10.75Z",
    fill: "currentColor"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "help",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 6.16667V5.16667H9.50001V7L8.00001 8V8.83333M8.00001 10.6667V10.66M14.1667 8C14.1667 11.4058 11.4058 14.1667 8.00001 14.1667C4.59425 14.1667 1.83334 11.4058 1.83334 8C1.83334 4.59424 4.59425 1.83333 8.00001 1.83333C11.4058 1.83333 14.1667 4.59424 14.1667 8ZM8.16668 10.6667C8.16668 10.7587 8.09206 10.8333 8.00001 10.8333C7.90796 10.8333 7.83334 10.7587 7.83334 10.6667C7.83334 10.5746 7.90796 10.5 8.00001 10.5C8.09206 10.5 8.16668 10.5746 8.16668 10.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5H1V16H6V10H10V16H15V5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0L15 5H1L8 0Z",
    fill: "currentColor"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "home2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.5H3V15H6.5V12.5C6.5 11.6716 7.17157 11 8 11C8.82843 11 9.5 11.6716 9.5 12.5V15H13V7.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5L13 7.5H3L8 4.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.4946 6.61468C0.770742 7.09298 1.38233 7.25685 1.86063 6.98071L8.01171 3.42938L14.1317 6.96279C14.61 7.23893 15.2216 7.07505 15.4978 6.59676C15.7739 6.11847 15.61 5.50688 15.1317 5.23074L8.01742 1.12328L8.01456 1.11833L8.01171 1.11998L8.00888 1.11835L8.00606 1.12324L0.860625 5.24866C0.382333 5.5248 0.218458 6.13639 0.4946 6.61468Z",
    fill: "currentColor"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon/lock",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_190)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C2.89543 6 2 6.89543 2 8V13C2 14.1046 2.89543 15 4 15H12C13.1046 15 14 14.1046 14 13V8C14 6.89543 13.1046 6 12 6H4ZM8 9C7.44772 9 7 9.44772 7 10V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V10C9 9.44772 8.55228 9 8 9Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    fill: "white",
    transform: "translate(2)"
  }))))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon/skip",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5547 3.03647L8.75192 7.16795C9.34566 7.56377 9.34566 8.43623 8.75192 8.83205L2.5547 12.9635C1.89015 13.4066 1 12.9302 1 12.1315L1 3.86852C1 3.06982 1.89015 2.59343 2.5547 3.03647Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 2,
    height: 12,
    rx: 1,
    fill: "currentColor"
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "image",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C1.44772 2 1 2.44772 1 3V13C1 13.5523 1.44772 14 2 14H14C14.5523 14 15 13.5523 15 13V3C15 2.44772 14.5523 2 14 2H2ZM13 4H3V12H13V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8C11.3284 8 12 7.32843 12 6.5 12 5.67157 11.3284 5 10.5 5 9.67157 5 9 5.67157 9 6.5 9 7.32843 9.67157 8 10.5 8ZM4 11.0237V8.02372C6 5.52371 7 6.00001 8.5 7.50004L12 11.0237H4Z",
    fill: "currentColor"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "in_out",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.99998H0V6.99999H8H16L8 0.999985V3.99998ZM8 12H16V8.99999H8L0 8.99999L8 15V12Z",
    fill: "currentColor"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "in_out2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.99998H0V7.99999H8H16L8 0.999985V4.99998ZM8 12H16V8.99999H8L0 8.99999L8 16L8 12Z",
    fill: "currentColor"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "input_number",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 3,
    width: 16,
    height: 10,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0H10 12 14V2H12V14H14V16H12 10 8V14H10V2H8V0ZM6.49999 5H4.49999 3.49999V6 7 7.5 8H4.74999V7.99907C4.93517 7.99907 5.11749 8.03966 5.2808 8.11726 5.44412 8.19485 5.58338 8.30705 5.68626 8.44391 5.78914 8.58078 5.85246 8.73808 5.87061 8.90189 5.88876 9.0657 5.86119 9.23097 5.79032 9.38304 5.71946 9.53511 5.60749 9.66931 5.46434 9.77373 5.3212 9.87816 5.15129 9.94959 4.96967 9.9817 4.78805 10.0138 4.60032 10.0056 4.42311 9.95783 4.24591 9.91005 4.08469 9.82416 3.95375 9.70777L3.159 10.4142C3.42064 10.6468 3.74276 10.8184 4.09685 10.9139 4.45093 11.0094 4.82604 11.0257 5.18894 10.9616 5.55185 10.8974 5.89135 10.7547 6.17737 10.546 6.4634 10.3374 6.68712 10.0692 6.82872 9.76537 6.97031 9.4615 7.02542 9.13128 6.98915 8.80397 6.95288 8.47665 6.82636 8.16233 6.62079 7.88886 6.41522 7.61539 6.13695 7.3912 5.81063 7.23616 5.48431 7.08111 5.12 7 4.74999 7H4.49999V6H6.49999V5Z",
    fill: "currentColor"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "italic",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 2.66667C5.99999 2.29848 6.29847 2 6.66666 2H12.6667C13.0348 2 13.3333 2.29848 13.3333 2.66667C13.3333 3.03486 13.0348 3.33333 12.6667 3.33333H10.1568L7.24012 12.6667H9.33332C9.70151 12.6667 9.99999 12.9651 9.99999 13.3333C9.99999 13.7015 9.70151 14 9.33332 14H3.33332C2.96513 14 2.66666 13.7015 2.66666 13.3333C2.66666 12.9651 2.96513 12.6667 3.33332 12.6667H5.8432L8.75986 3.33333H6.66666C6.29847 3.33333 5.99999 3.03486 5.99999 2.66667Z",
    fill: "currentColor"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "join",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 5.5,
    cy: 7.5,
    r: 5.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 10.5,
    cy: 7.5,
    r: 5.5,
    fill: "currentColor"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "join-1",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.5L3 5.5L0 5.5V2.5H3ZM16 2.5V5.5L13 5.5V2.5H16ZM16 9.5V6.5L13 6.5V9.5L16 9.5ZM3 6.5V9.5H0V6.5H3ZM16 13.5L16 10.5H13L13 13.5H16ZM3 10.5L3 13.5H0V10.5H3ZM7.5 5V7.5H5V8.5H7.5V11H8.5V8.5H11V7.5H8.5V5H7.5Z",
    fill: "currentColor"
  })))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "join2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 6,
    cy: 6,
    r: 6,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 10,
    cy: 10,
    r: 6,
    fill: "currentColor"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "join2-1",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.52,
    cx: 5.5,
    cy: 8,
    r: 5.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.52,
    cx: 10.5,
    cy: 8,
    r: 5.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.9003C9.78084 11.9899 11 10.1373 11 8.00001C11 5.86266 9.78084 4.01007 8 3.09972C6.21916 4.01007 5 5.86266 5 8.00001C5 10.1373 6.21916 11.9899 8 12.9003Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.87,
    cx: 5.5,
    cy: 8,
    r: 5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.87,
    cx: 10.5,
    cy: 8,
    r: 5,
    stroke: "currentColor"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "join_full",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 11.7422C6.79402 10.935 6 9.56021 6 8C6 6.4398 6.79401 5.06504 7.99999 4.25778C9.20598 5.06504 10 6.4398 10 8.00002C10 9.56022 9.20599 10.935 8.00001 11.7422Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5C8.53757 13.5 11 11.0376 11 8C11 4.96243 8.53757 2.5 5.5 2.5C2.46243 2.5 0 4.96243 0 8C0 11.0376 2.46243 13.5 5.5 13.5ZM5.5 12.5C7.98528 12.5 10 10.4853 10 8C10 5.51472 7.98528 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13.5C13.5376 13.5 16 11.0376 16 8C16 4.96243 13.5376 2.5 10.5 2.5C7.46243 2.5 5 4.96243 5 8C5 11.0376 7.46243 13.5 10.5 13.5ZM10.5 12.5C12.9853 12.5 15 10.4853 15 8C15 5.51472 12.9853 3.5 10.5 3.5C8.01472 3.5 6 5.51472 6 8C6 10.4853 8.01472 12.5 10.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00094 3.75639C6.5315 3.59035 6.0263 3.5 5.5 3.5 3.01472 3.5 1 5.51472 1 8 1 10.4853 3.01472 12.5 5.5 12.5 6.0263 12.5 6.5315 12.4096 7.00094 12.2436 5.77889 11.2348 5 9.70837 5 8 5 6.29163 5.77889 4.76517 7.00094 3.75639ZM8.99905 12.2436C10.2211 11.2348 11 9.70837 11 8 11 6.29163 10.2211 4.76517 8.99905 3.75639 9.46849 3.59035 9.97369 3.5 10.5 3.5 12.9853 3.5 15 5.51472 15 8 15 10.4853 12.9853 12.5 10.5 12.5 9.97369 12.5 9.46849 12.4096 8.99905 12.2436Z",
    fill: "currentColor"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "join_inner",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 11.7422C6.79402 10.935 6 9.56021 6 8C6 6.4398 6.79401 5.06504 7.99999 4.25778C9.20598 5.06504 10 6.4398 10 8.00002C10 9.56022 9.20599 10.935 8.00001 11.7422Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5C8.53757 13.5 11 11.0376 11 8C11 4.96243 8.53757 2.5 5.5 2.5C2.46243 2.5 0 4.96243 0 8C0 11.0376 2.46243 13.5 5.5 13.5ZM5.5 12.5C7.98528 12.5 10 10.4853 10 8C10 5.51472 7.98528 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13.5C13.5376 13.5 16 11.0376 16 8C16 4.96243 13.5376 2.5 10.5 2.5C7.46243 2.5 5 4.96243 5 8C5 11.0376 7.46243 13.5 10.5 13.5ZM10.5 12.5C12.9853 12.5 15 10.4853 15 8C15 5.51472 12.9853 3.5 10.5 3.5C8.01472 3.5 6 5.51472 6 8C6 10.4853 8.01472 12.5 10.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "join_left_exclusive",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5C8.53757 13.5 11 11.0376 11 8C11 4.96243 8.53757 2.5 5.5 2.5C2.46243 2.5 0 4.96243 0 8C0 11.0376 2.46243 13.5 5.5 13.5ZM5.5 12.5C7.98528 12.5 10 10.4853 10 8C10 5.51472 7.98528 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13.5C13.5376 13.5 16 11.0376 16 8C16 4.96243 13.5376 2.5 10.5 2.5C7.46243 2.5 5 4.96243 5 8C5 11.0376 7.46243 13.5 10.5 13.5ZM10.5 12.5C12.9853 12.5 15 10.4853 15 8C15 5.51472 12.9853 3.5 10.5 3.5C8.01472 3.5 6 5.51472 6 8C6 10.4853 8.01472 12.5 10.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00094 3.75639C6.5315 3.59035 6.0263 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5C6.0263 12.5 6.5315 12.4096 7.00094 12.2436C5.77889 11.2348 5 9.70837 5 8C5 6.29163 5.77889 4.76517 7.00094 3.75639Z",
    fill: "currentColor"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "join_left_outer",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 11.7422C6.79402 10.935 6 9.56021 6 8C6 6.4398 6.79401 5.06504 7.99999 4.25778C9.20598 5.06504 10 6.4398 10 8.00002C10 9.56022 9.20599 10.935 8.00001 11.7422Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5C8.53757 13.5 11 11.0376 11 8C11 4.96243 8.53757 2.5 5.5 2.5C2.46243 2.5 0 4.96243 0 8C0 11.0376 2.46243 13.5 5.5 13.5ZM5.5 12.5C7.98528 12.5 10 10.4853 10 8C10 5.51472 7.98528 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13.5C13.5376 13.5 16 11.0376 16 8C16 4.96243 13.5376 2.5 10.5 2.5C7.46243 2.5 5 4.96243 5 8C5 11.0376 7.46243 13.5 10.5 13.5ZM10.5 12.5C12.9853 12.5 15 10.4853 15 8C15 5.51472 12.9853 3.5 10.5 3.5C8.01472 3.5 6 5.51472 6 8C6 10.4853 8.01472 12.5 10.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00094 3.75639C6.5315 3.59035 6.0263 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5C6.0263 12.5 6.5315 12.4096 7.00094 12.2436C5.77889 11.2348 5 9.70837 5 8C5 6.29163 5.77889 4.76517 7.00094 3.75639Z",
    fill: "currentColor"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "join_right_exclusive",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5C8.53757 13.5 11 11.0376 11 8C11 4.96243 8.53757 2.5 5.5 2.5C2.46243 2.5 0 4.96243 0 8C0 11.0376 2.46243 13.5 5.5 13.5ZM5.5 12.5C7.98528 12.5 10 10.4853 10 8C10 5.51472 7.98528 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13.5C13.5376 13.5 16 11.0376 16 8C16 4.96243 13.5376 2.5 10.5 2.5C7.46243 2.5 5 4.96243 5 8C5 11.0376 7.46243 13.5 10.5 13.5ZM10.5 12.5C12.9853 12.5 15 10.4853 15 8C15 5.51472 12.9853 3.5 10.5 3.5C8.01472 3.5 6 5.51472 6 8C6 10.4853 8.01472 12.5 10.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99905 12.2436C10.2211 11.2348 11 9.70837 11 8C11 6.29163 10.2211 4.76517 8.99905 3.75639C9.46849 3.59035 9.97369 3.5 10.5 3.5C12.9853 3.5 15 5.51472 15 8C15 10.4853 12.9853 12.5 10.5 12.5C9.97369 12.5 9.46849 12.4096 8.99905 12.2436Z",
    fill: "currentColor"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "join_right_outer",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 11.7422C6.79402 10.935 6 9.56021 6 8C6 6.4398 6.79401 5.06504 7.99999 4.25778C9.20598 5.06504 10 6.4398 10 8.00002C10 9.56022 9.20599 10.935 8.00001 11.7422Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 13.5C8.53757 13.5 11 11.0376 11 8C11 4.96243 8.53757 2.5 5.5 2.5C2.46243 2.5 0 4.96243 0 8C0 11.0376 2.46243 13.5 5.5 13.5ZM5.5 12.5C7.98528 12.5 10 10.4853 10 8C10 5.51472 7.98528 3.5 5.5 3.5C3.01472 3.5 1 5.51472 1 8C1 10.4853 3.01472 12.5 5.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13.5C13.5376 13.5 16 11.0376 16 8C16 4.96243 13.5376 2.5 10.5 2.5C7.46243 2.5 5 4.96243 5 8C5 11.0376 7.46243 13.5 10.5 13.5ZM10.5 12.5C12.9853 12.5 15 10.4853 15 8C15 5.51472 12.9853 3.5 10.5 3.5C8.01472 3.5 6 5.51472 6 8C6 10.4853 8.01472 12.5 10.5 12.5Z",
    fill: "currentColor",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99905 12.2436C10.2211 11.2348 11 9.70837 11 8C11 6.29163 10.2211 4.76517 8.99905 3.75639C9.46849 3.59035 9.97369 3.5 10.5 3.5C12.9853 3.5 15 5.51472 15 8C15 10.4853 12.9853 12.5 10.5 12.5C9.97369 12.5 9.46849 12.4096 8.99905 12.2436Z",
    fill: "currentColor"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "key",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.5C16 8.53757 13.5376 11 10.5 11C10.3315 11 10.1647 10.9924 10 10.9776V11H7.5L7 13H4.5L4 15L2 16H1L0 14.5V12L5.16351 6.83649C5.0567 6.40863 5 5.96094 5 5.5C5 2.46243 7.46243 0 10.5 0C13.5376 0 16 2.46243 16 5.5ZM10.5 7C11.3284 7 12 6.32843 12 5.5C12 4.67157 11.3284 4 10.5 4C9.67157 4 9 4.67157 9 5.5C9 6.32843 9.67157 7 10.5 7Z",
    fill: "currentColor"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    id: "key_add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1275 8.47388C15.6796 7.61646 16 6.59564 16 5.5C16 2.46243 13.5376 0 10.5 0C7.46243 0 5 2.46243 5 5.5C5 5.96094 5.0567 6.40863 5.16351 6.83649L0 12V14.5L1 16H2L4 15L4.5 13H7L7.5 11H8.41604C9.1876 9.2341 10.9497 8 13 8C13.7608 8 14.4819 8.16992 15.1275 8.47388ZM12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14V15V16H12V15V14H10V12H12V10H14V12H16V14H14Z",
    fill: "currentColor"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    id: "key_cmd",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 5.5V4.5C5.5 3.94772 5.05228 3.5 4.5 3.5C3.94772 3.5 3.5 3.94772 3.5 4.5C3.5 5.05228 3.94772 5.5 4.5 5.5H5.5ZM5.5 7H4.5C3.11929 7 2 5.88071 2 4.5C2 3.11929 3.11929 2 4.5 2C5.88071 2 7 3.11929 7 4.5V5.5H9V4.5C9 3.11929 10.1193 2 11.5 2C12.8807 2 14 3.11929 14 4.5C14 5.88071 12.8807 7 11.5 7H10.5V9H11.5C12.8807 9 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5V10.5H7V11.5C7 12.8807 5.88071 14 4.5 14C3.11929 14 2 12.8807 2 11.5C2 10.1193 3.11929 9 4.5 9H5.5V7ZM5.5 10.5H4.5C3.94772 10.5 3.5 10.9477 3.5 11.5C3.5 12.0523 3.94772 12.5 4.5 12.5C5.05228 12.5 5.5 12.0523 5.5 11.5V10.5ZM7 9V8.5V7.5V7H7.5H8.5H9V7.5V8.5V9H8.5H7.5H7ZM10.5 10.5V11.5C10.5 12.0523 10.9477 12.5 11.5 12.5C12.0523 12.5 12.5 12.0523 12.5 11.5C12.5 10.9477 12.0523 10.5 11.5 10.5H10.5ZM10.5 5.5H11.5C12.0523 5.5 12.5 5.05228 12.5 4.5C12.5 3.94772 12.0523 3.5 11.5 3.5C10.9477 3.5 10.5 3.94772 10.5 4.5V5.5Z",
    fill: "currentColor"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    id: "key_ctrl",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41421 6.41421L8 5L6.58579 6.41421L3.75736 9.24264L5.17157 10.6569L8 7.82843L10.8284 10.6569L12.2426 9.24264L9.41421 6.41421Z",
    fill: "currentColor"
  }))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    id: "key_option",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 16,
    height: 16,
    rx: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5H6.35L9.6 11H13",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4H13V6H10L9 4Z",
    fill: "currentColor"
  }))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    id: "keyboard_shortcuts",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10.5,
    width: 8,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6.5,
    width: 8,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2.5,
    width: 4,
    height: 4,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 10.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    id: "lab",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5 2C4.44771 2 4 1.55228 4 1C4 0.447715 4.44771 0 5 0H10C10.5523 0 11 0.447715 11 1C11 1.55228 10.5523 2 10 2V6L14.5 12C14.8139 12.4178 15 12.9372 15 13.5C15 14.8807 13.8807 16 12.5 16H2.5C1.11929 16 0 14.8807 0 13.5C0 12.9371 0.186045 12.4176 0.5 11.9998L5 6V2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 16H12.5C13.8807 16 15 14.8807 15 13.5C15 12.9372 14.8139 12.4178 14.5 12L13 10H1.99988L0.5 11.9998C0.186045 12.4176 0 12.9371 0 13.5C0 14.8807 1.11929 16 2.5 16Z",
    fill: "currentColor"
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    id: "lab2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5 2C4.44771 2 4 1.55228 4 1C4 0.447715 4.44771 0 5 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2V6L15.5 12C15.8139 12.4178 16 12.9372 16 13.5C16 14.8807 14.8807 16 13.5 16H2.5C1.11929 16 0 14.8807 0 13.5C0 12.9371 0.186045 12.4176 0.5 11.9998L5 6V2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 16H13.5C14.8807 16 16 14.8807 16 13.5C16 12.9372 15.8139 12.4178 15.5 12L14 10H1.99988L0.5 11.9998C0.186045 12.4176 0 12.9371 0 13.5C0 14.8807 1.11929 16 2.5 16Z",
    fill: "currentColor"
  }))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    id: "lab3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5 3C4.44771 3 4 2.5 4 1.5C4 0.5 4.44771 0 5 0H11C11.5523 0 12 0.5 12 1.5C12 2.5 11.5523 3 11 3V6L14.5 12C14.8139 12.4178 15 12.9372 15 13.5C15 14.8807 13.8807 16 12.5 16H3.5C2.11929 16 1 14.8807 1 13.5C1 12.9371 1.18604 12.4176 1.5 11.9998L5 6V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 16H12.5C13.8807 16 15 14.8807 15 13.5C15 12.9372 14.8139 12.4178 14.5 12L13.3333 10H2.66657L1.5 11.9998C1.18604 12.4176 1 12.9371 1 13.5C1 14.8807 2.11929 16 3.5 16Z",
    fill: "currentColor"
  }))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    id: "libraries",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 8,
    y: 8,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    y: 8,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 8,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    id: "local_scope",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 8,
    cy: 8,
    r: 5.5,
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    fill: "currentColor"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    id: "local_scope2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    fill: "currentColor"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    id: "local_scope3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H4V4H0V0ZM4 6H0V10H4V6ZM4 12H0V16H4V12ZM10 12H6V16H10V12ZM6 0H10V4H6V0ZM16 12H12V16H16V12ZM12 6H16V10H12V6ZM16 0H12V4H16V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 4,
    height: 4,
    fill: "currentColor"
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    id: "local_scope4",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.895431 0 2 0H4V4H0V2ZM0 6V10H4V6H0ZM0 12V14C0 15.1046 0.895431 16 2 16H4V12H0ZM10 12H6V16H10V12ZM6 0H10V4H6V0ZM16 14V12H12V16H14C15.1046 16 16 15.1046 16 14ZM12 10V6H16V10H12ZM14 0H12V4H16V2C16 0.895431 15.1046 0 14 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 4,
    height: 4,
    fill: "currentColor"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    id: "location",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.5C10.5 5.88071 9.38071 7 8 7C6.61929 7 5.5 5.88071 5.5 4.5C5.5 3.11929 6.61929 2 8 2C9.38071 2 10.5 3.11929 10.5 4.5ZM11.3099 7.54874C12.0487 6.74702 12.5 5.67621 12.5 4.5C12.5 2.01472 10.4853 0 8 0C5.51472 0 3.5 2.01472 3.5 4.5C3.5 5.67621 3.95127 6.74702 4.69011 7.54874L8 12.75L11.3099 7.54874ZM4.76113 10.832C2.81214 11.2636 1.5 12.0729 1.5 13C1.5 14.3807 4.41015 15.5 8 15.5C11.5899 15.5 14.5 14.3807 14.5 13C14.5 12.0729 13.1879 11.2636 11.2389 10.832L10.7171 11.7451C11.292 11.8558 11.8049 11.9993 12.2372 12.1656C12.7581 12.3659 13.1111 12.58 13.3164 12.7667C13.4607 12.8979 13.4928 12.9766 13.4992 13C13.4928 13.0234 13.4607 13.102 13.3164 13.2332C13.1111 13.42 12.7581 13.6341 12.2372 13.8344C11.2021 14.2325 9.70428 14.5 8 14.5C6.29572 14.5 4.79795 14.2325 3.76278 13.8344C3.24187 13.6341 2.88893 13.42 2.68357 13.2332C2.53928 13.102 2.50716 13.0234 2.50079 13C2.50716 12.9766 2.53928 12.8979 2.68357 12.7667C2.88893 12.58 3.24187 12.3659 3.76278 12.1656C4.19505 11.9993 4.70798 11.8558 5.28294 11.7451L4.76113 10.832ZM13.5006 12.9926C13.5007 12.9926 13.5006 12.9938 13.5001 12.9964C13.5002 12.9938 13.5005 12.9926 13.5006 12.9926ZM2.49939 12.9926C2.49949 12.9926 2.49976 12.9938 2.4999 12.9964C2.49937 12.9938 2.49929 12.9926 2.49939 12.9926ZM2.49939 13.0074C2.49929 13.0074 2.49937 13.0061 2.4999 13.0036C2.49976 13.0061 2.49949 13.0074 2.49939 13.0074ZM13.5001 13.0036L13.5006 13.0062C13.5007 13.007 13.5007 13.0074 13.5006 13.0074L13.5005 13.0069L13.5001 13.0036Z",
    fill: "currentColor"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    id: "location2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4.5C9.5 5.32843 8.82843 6 8 6C7.17157 6 6.5 5.32843 6.5 4.5C6.5 3.67157 7.17157 3 8 3C8.82843 3 9.5 3.67157 9.5 4.5ZM11.3099 7.54874C12.0487 6.74702 12.5 5.67621 12.5 4.5C12.5 2.01472 10.4853 0 8 0C5.51472 0 3.5 2.01472 3.5 4.5C3.5 5.67621 3.95127 6.74702 4.69011 7.54874L8 12.75L11.3099 7.54874ZM4.79855 10.8974C2.5427 11.3444 1 12.2491 1 13.2923C1 14.7792 4.13401 15.9846 8 15.9846C11.866 15.9846 15 14.7792 15 13.2923C15 12.2491 13.4573 11.3444 11.2015 10.8974L10.4111 12.2805C11.1877 12.4024 11.8667 12.5791 12.4113 12.7886C12.8753 12.9671 13.1841 13.1473 13.3676 13.2923C13.1841 13.4373 12.8753 13.6176 12.4113 13.796C11.3562 14.2018 9.79702 14.4846 8 14.4846C6.20298 14.4846 4.64381 14.2018 3.58872 13.796C3.12468 13.6176 2.81592 13.4373 2.63243 13.2923C2.81592 13.1473 3.12468 12.9671 3.58872 12.7886C4.13333 12.5791 4.81225 12.4024 5.58886 12.2805L4.79855 10.8974ZM13.5348 13.1286C13.5349 13.1286 13.5339 13.1306 13.5311 13.1346C13.5333 13.1306 13.5346 13.1286 13.5348 13.1286ZM2.46521 13.1286C2.46537 13.1286 2.46675 13.1306 2.46887 13.1346C2.46611 13.1306 2.46505 13.1286 2.46521 13.1286ZM2.46521 13.456C2.46505 13.456 2.46611 13.454 2.46887 13.45C2.46675 13.454 2.46537 13.456 2.46521 13.456ZM13.5311 13.45L13.5335 13.4537C13.5345 13.4552 13.5349 13.456 13.5348 13.456C13.5346 13.456 13.5333 13.454 13.5311 13.45Z",
    fill: "currentColor"
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    id: "log",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 4H16V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.44772 0 2 .44772 2 1V2C.89543 2 0 2.89543 0 4H3 8 13 16C16 2.89543 15.1046 2 14 2V1C14 .44772 13.5523 0 13 0 12.4477 0 12 .44772 12 1V2H9V1C9 .44772 8.55229 0 8 0 7.44772 0 7 .44772 7 1V2H4V1C4 .44772 3.55228 0 3 0ZM4 5.5H2V7.5H4V5.5ZM4 8.5H2V10.5H4V8.5ZM2 11.5H4V13.5H2V11.5ZM14 5.5H5V7.5H14V5.5ZM5 8.5H14V10.5H5V8.5ZM14 11.5H5V13.5H14V11.5Z",
    fill: "currentColor"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    id: "log_cloud",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03823 6.31894C2.37639 3.32591 4.91657 1 8 1C10.7676 1 13.0976 2.87386 13.7904 5.42207C15.1006 6.07898 16 7.43446 16 9C16 9.16933 15.9895 9.3362 15.9691 9.5C15.9895 9.6638 16 9.83067 16 10C16 10.1693 15.9895 10.3362 15.9691 10.5C15.9895 10.6638 16 10.8307 16 11C16 13.2091 14.2091 15 12 15H3.5C1.567 15 0 13.433 0 11.5C0 11.3302 0.0120861 11.1633 0.0354447 11C0.0120861 10.8367 0 10.6698 0 10.5C0 10.3302 0.0120861 10.1633 0.0354447 10C0.0120861 9.8367 0 9.66976 0 9.5C0 8.08881 0.835182 6.87268 2.03823 6.31894Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 2,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 5,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 5,
    height: 2,
    fill: "currentColor"
  }))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    id: "logout",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 16,
    y: 14,
    width: 10,
    height: 12,
    rx: 2,
    transform: "rotate(180 16 14)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8L4 11V9H11V7L4 7V5L0 8Z",
    fill: "currentColor"
  }))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    id: "make_node_def_local_copy",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5L8 1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7L8 10L6 7L10 7Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10L15 13C15 14.1046 14.1046 15 13 15L3 15C1.89543 15 1 14.1046 1 13L1 10",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    id: "map_row",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11.75 7.25 16 8.75 13.75 12.5 14.75 8.25 10.5 6.75 12.75 3 11.75ZM11 5H15V9H11V5ZM6 5H10V9H6V5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 4,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 0H15V4H11V0ZM6 0H10V4H6V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 1,
    width: 4,
    height: 4,
    fill: "currentColor"
  }))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    id: "marketplace",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 8,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    y: 8,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 8,
    y: 8,
    width: 7,
    height: 7,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0V7M0 3.5H7",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    id: "math",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08269 2.00514C6.44804 2.05081 6.70719 2.384 6.66152 2.74935L6.42186 4.66666H10.4115L10.6718 2.58397C10.7175 2.21862 11.0507 1.95947 11.416 2.00514C11.7814 2.05081 12.0405 2.384 11.9949 2.74935L11.7552 4.66666H13.3333C13.7015 4.66666 14 4.96514 14 5.33333C14 5.70152 13.7015 5.99999 13.3333 5.99999H11.5885L11.0885 9.99999H13.3333C13.7015 9.99999 14 10.2985 14 10.6667C14 11.0349 13.7015 11.3333 13.3333 11.3333H10.9219L10.6615 13.416C10.6159 13.7814 10.2827 14.0405 9.91731 13.9948C9.55196 13.9492 9.29281 13.616 9.33848 13.2506L9.57815 11.3333H5.58852L5.32819 13.416C5.28252 13.7814 4.94932 14.0405 4.58398 13.9948C4.21863 13.9492 3.95948 13.616 4.00515 13.2506L4.24481 11.3333H2.66667C2.29848 11.3333 2 11.0349 2 10.6667C2 10.2985 2.29848 9.99999 2.66667 9.99999H4.41148L4.91148 5.99999H2.66667C2.29848 5.99999 2 5.70152 2 5.33333C2 4.96514 2.29848 4.66666 2.66667 4.66666H5.07815L5.33848 2.58397C5.38415 2.21862 5.71734 1.95947 6.08269 2.00514ZM6.25519 5.99999L5.75519 9.99999H9.74481L10.2448 5.99999H6.25519Z",
    fill: "currentColor"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    id: "metadata",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 6.33333C6.78105 6.33333 6.33333 6.78105 6.33333 7.33333 6.33333 7.76874 6.6116 8.13915 7 8.27643V10.6667C7 11.219 7.44772 11.6667 8 11.6667 8.55228 11.6667 9 11.219 9 10.6667V7.33333C9 6.78105 8.55228 6.33333 8 6.33333H7.33333ZM7.16667 5.33333C7.16667 4.8731 7.53977 4.5 8 4.5 8.46024 4.5 8.83334 4.8731 8.83334 5.33333 8.83334 5.79357 8.46024 6.16667 8 6.16667 7.53977 6.16667 7.16667 5.79357 7.16667 5.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8Z",
    fill: "currentColor"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    id: "microphone",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 6,
    height: 11,
    rx: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5C3 5.22386 3.22386 5 3.5 5V5C3.77614 5 4 5.22386 4 5.5V6H3V5.5ZM12 5.5C12 5.22386 12.2239 5 12.5 5V5C12.7761 5 13 5.22386 13 5.5V6H12V5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6H3V8C3 10.419 4.71776 12.4367 7 12.9V15H5.5C5.22386 15 5 15.2239 5 15.5C5 15.7761 5.22386 16 5.5 16H7H9H10.5C10.7761 16 11 15.7761 11 15.5C11 15.2239 10.7761 15 10.5 15H9V12.9C11.2822 12.4367 13 10.419 13 8V6H12V8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8V6Z",
    fill: "currentColor"
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 16,
    height: 2,
    fill: "currentColor"
  }))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    id: "mixed",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.33334C2.29848 3.33334 2 3.63182 2 4.00001 2 4.3682 2.29848 4.66668 2.66667 4.66668H13.3333C13.7015 4.66668 14 4.3682 14 4.00001 14 3.63182 13.7015 3.33334 13.3333 3.33334H2.66667ZM11.9461 6.40406C11.841 6.15894 11.6 6.00001 11.3333 6.00001 11.0666 6.00001 10.8256 6.15894 10.7206 6.40406L9.82562 8.49229 7.73739 9.38725C7.49226 9.4923 7.33333 9.73332 7.33333 10 7.33333 10.2667 7.49226 10.5077 7.73739 10.6128L9.82562 11.5077 10.7206 13.596C10.8256 13.8411 11.0666 14 11.3333 14 11.6 14 11.841 13.8411 11.9461 13.596L12.8411 11.5077 14.9293 10.6128C15.1744 10.5077 15.3333 10.2667 15.3333 10 15.3333 9.73332 15.1744 9.4923 14.9293 9.38725L12.8411 8.49229 11.9461 6.40406ZM2.66667 7.33334C2.29848 7.33334 2 7.63182 2 8.00001 2 8.3682 2.29848 8.66668 2.66667 8.66668H6C6.36819 8.66668 6.66667 8.3682 6.66667 8.00001 6.66667 7.63182 6.36819 7.33334 6 7.33334H2.66667ZM2.66667 11.3333C2.29848 11.3333 2 11.6318 2 12 2 12.3682 2.29848 12.6667 2.66667 12.6667H4.66667C5.03486 12.6667 5.33333 12.3682 5.33333 12 5.33333 11.6318 5.03486 11.3333 4.66667 11.3333H2.66667Z",
    fill: "currentColor"
  }))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    id: "navigate_back",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 12L2.66666 8.00001L6.66666 4M3.33332 8.00001H13.3333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    id: "navigate_breadcrumb",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 10.6667L9.33332 8.00001L6.66666 5.33334",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    id: "navigate_forward",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 4L13.3333 7.99999L9.33334 12M12.6667 7.99999H2.66668",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    id: "navigate_up",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66666L7.99999 2.66666L12 6.66666M7.99999 3.33332V13.3333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    id: "no_auto_replay",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9946 4L5.99463 0V3.00002C2.68878 3.00924 0.0117188 5.69199 0.0117188 9C0.0117188 9.85105 0.188908 10.6607 0.508408 11.3941L2.25769 10.3842C2.0986 9.95285 2.01172 9.48657 2.01172 9C2.01172 6.79656 3.79335 5.00924 5.99463 5.00004V8L12.9946 4ZM11.6263 7.28463L13.3624 6.28229L15.0022 5.33554L16.0022 7.06759L13.9646 8.24403C13.9957 8.49164 14.0117 8.74395 14.0117 9C14.0117 12.3137 11.3254 15 8.01172 15H6.01172C5.05341 15 4.14757 14.7753 3.34401 14.3758L1 15.7291L0 13.9971L1.60404 13.071L3.40299 12.0323L11.6263 7.28463ZM5.74242 12.9911L11.9937 9.38188C11.8015 11.4119 10.0921 13 8.01172 13H6.01172C5.92122 13 5.83142 12.997 5.74242 12.9911Z",
    fill: "currentColor"
  }))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    id: "not_cloud",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12013 11.776L12.7387 5.06807C12.7404 5.06838 12.742 5.06869 12.7437 5.06901L16.0071 3.18391L16.0071 5.49044L14.828 6.17119C15.5521 6.89508 16 7.89524 16 9C16 11.2091 14.2091 13 12 13H4H3.5V12.9691C3.38339 12.9545 3.26833 12.9349 3.15506 12.9106L0.00883415 14.7271L-0.00159454 12.4312L1.12463 11.7807C1.12313 11.7791 1.12163 11.7776 1.12013 11.776ZM11.5851 4.00268L0.298513 10.519C0.106104 10.0506 3.05765e-06 9.53771 3.05765e-06 9C3.05765e-06 7.51015 0.814519 6.21055 2.02254 5.52219C2.26308 2.9849 4.39974 1 7 1C9.05136 1 10.8142 2.23534 11.5851 4.00268Z",
    fill: "currentColor"
  }))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    id: "not_exclamation",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00159 1H8.00159C7.44931 1 7.00159 1.44772 7.00159 2V5.6499L10.0016 3.91785V2C10.0016 1.44772 9.55388 1 9.00159 1ZM7.00159 7.38683V7.38129L10.0016 5.64924V5.6539L16.0087 2.18391L16.0087 4.49044L10.0016 7.95867V10C10.0016 10.5523 9.55388 11 9.00159 11H8.00159C7.44931 11 7.00159 10.5523 7.00159 10V9.69072L0.0104287 13.7271L0 11.4312L7.00159 7.38683ZM9.00159 12H8.00159C7.44931 12 7.00159 12.4477 7.00159 13V14C7.00159 14.5523 7.44931 15 8.00159 15H9.00159C9.55388 15 10.0016 14.5523 10.0016 14V13C10.0016 12.4477 9.55388 12 9.00159 12Z",
    fill: "currentColor"
  }))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    id: "not_paragraph",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0129 3.33333L14.9924 2.7678C14.9922 2.76898 14.992 2.77015 14.9918 2.77132L16.0087 2.18391L16.0087 4.49044L11.6667 6.99733V13.3333C11.6667 13.7015 11.3682 14 11 14C10.6318 14 10.3333 13.7015 10.3333 13.3333V7.76713L8.33334 8.92183V13.3333C8.33334 13.7015 8.03487 14 7.66668 14C7.29849 14 7.00001 13.7015 7.00001 13.3333V9.69163L0.0104287 13.7271L0 11.4312L5.09228 8.48973C5.09007 8.48898 5.08786 8.48822 5.08565 8.48746L8.33334 6.6124V6.61755L10.3333 5.46227V5.4577L11.6667 4.6879V4.69207L14.0189 3.33333H14.0129ZM10.3333 3.33333V3.72632L13.3234 2H6.16668C4.32573 2 2.83334 3.49238 2.83334 5.33333C2.83334 6.19051 3.15689 6.97212 3.68853 7.5627L4.88725 6.87062C4.44692 6.50375 4.16668 5.95127 4.16668 5.33333C4.16668 4.22876 5.06211 3.33333 6.16668 3.33333H7.00001V5.65082L8.33334 4.88102V3.33333H10.3333Z",
    fill: "currentColor"
  }))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    id: "numbered-list",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35047 2.4329C4.54701 2.55437 4.66665 2.76895 4.66665 3V6.33333C4.66665 6.70152 4.36817 7 3.99998 7C3.63179 7 3.33332 6.70152 3.33332 6.33333V4.07869L2.96479 4.26295C2.63547 4.42761 2.23502 4.29413 2.07036 3.96481C1.9057 3.63549 2.03919 3.23504 2.36851 3.07038L3.70184 2.40371C3.9085 2.30039 4.15393 2.31143 4.35047 2.4329ZM8 4C7.63181 4 7.33333 4.29848 7.33333 4.66667C7.33333 5.03486 7.63181 5.33333 8 5.33333H13.3333C13.7015 5.33333 14 5.03486 14 4.66667C14 4.29848 13.7015 4 13.3333 4H8ZM8 10.6667C7.63181 10.6667 7.33333 10.9651 7.33333 11.3333C7.33333 11.7015 7.63181 12 8 12H13.3333C13.7015 12 14 11.7015 14 11.3333C14 10.9651 13.7015 10.6667 13.3333 10.6667H8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23954 10.5286L3.23879 10.5292L3.23791 10.5299L3.23659 10.5309L3.23593 10.5314C2.94427 10.7524 2.52841 10.697 2.30492 10.4065C2.08043 10.1146 2.13502 9.69607 2.42686 9.47158L2.46567 9.44298C2.48549 9.42884 2.51216 9.4104 2.54488 9.38911C2.60983 9.34685 2.70125 9.29167 2.81242 9.2364C3.02432 9.13103 3.35796 9 3.74068 9C4.62028 9 5.33333 9.71305 5.33333 10.5927C5.33333 11.1029 5.11247 11.4947 4.84478 11.7857C4.64076 12.0074 4.3929 12.188 4.17658 12.3333H4.83333C5.20152 12.3333 5.5 12.6318 5.5 13C5.5 13.3682 5.20152 13.6667 4.83333 13.6667H2.66667C2.29848 13.6667 2 13.3682 2 13C2 12.4971 2.26134 12.1341 2.51903 11.8883C2.73738 11.68 3.01384 11.5004 3.23119 11.3592L3.30187 11.3132C3.55833 11.1455 3.74012 11.0171 3.86355 10.8829C3.97086 10.7663 4 10.6823 4 10.5927C4 10.4494 3.8839 10.3333 3.74068 10.3333C3.64939 10.3333 3.52935 10.369 3.40608 10.4303C3.34967 10.4583 3.30312 10.4865 3.27201 10.5067C3.2567 10.5167 3.24527 10.5245 3.23954 10.5286Z",
    fill: "currentColor"
  }))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    id: "open",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0V2H12.5858L8.00197 6.58385C7.61144 6.97437 7.61144 7.60754 8.00197 7.99806C8.39249 8.38859 9.02566 8.38859 9.41618 7.99806L14 3.41425V6H16L16 2L16 0H14H10ZM7 0V2H3C2.44772 2 2 2.44772 2 3V13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13V9H16L16 13C16 14.6569 14.6569 16 13 16H3C1.34315 16 0 14.6569 0 13V3C0 1.34315 1.34315 0 3 0H7Z",
    fill: "currentColor"
  }))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    id: "open_count",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2V6H14V3.41425L9.41618 7.99806C9.02566 8.38859 8.39249 8.38859 8.00197 7.99806C7.61144 7.60754 7.61144 6.97437 8.00197 6.58385L12.5858 2H10V0H14C15.1046 0 16 0.89543 16 2ZM2 2H8V0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H14C15.1046 16 16 15.1046 16 14V8H14V14H2V2Z",
    fill: "currentColor"
  }))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    id: "open_in_file_browser",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6V0H10V2H14V6H16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2921 2.12132C15.6826 1.7308 15.6826 1.09763 15.2921 0.707107C14.9016 0.316582 14.2684 0.316582 13.8779 0.707107L8.22301 6.36199C7.83249 6.75251 7.83249 7.38568 8.22301 7.7762C8.61354 8.16673 9.2467 8.16673 9.63722 7.7762L15.2921 2.12132Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C0.895431 1 0 1.89543 0 3V6H16V5C16 3.89543 15.1046 3 14 3H8C8 1.89543 7.10457 1 6 1H2ZM0 13V7H16V13C16 14.1046 15.1046 15 14 15H2C0.89543 15 0 14.1046 0 13Z",
    fill: "currentColor"
  })))), _symbol154 || (_symbol154 = /*#__PURE__*/React.createElement("symbol", {
    id: "operators",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 2.66667V4.66667M4.66667 4.66667V6.66667M4.66667 4.66667H2.66667M4.66667 4.66667H6.66667M12.7474 9.91878L11.3332 11.333M11.3332 11.333L9.91896 12.7472M11.3332 11.333L9.91896 9.91878M11.3332 11.333L12.7474 12.7472M2.66667 9.33334H6.66667V13.3333H2.66667V9.33334ZM11.3333 6.66667C10.2288 6.66667 9.33334 5.77124 9.33334 4.66667C9.33334 3.5621 10.2288 2.66667 11.3333 2.66667C12.4379 2.66667 13.3333 3.5621 13.3333 4.66667C13.3333 5.77124 12.4379 6.66667 11.3333 6.66667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol155 || (_symbol155 = /*#__PURE__*/React.createElement("symbol", {
    id: "order",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66668 2C5.03487 2 5.33334 2.29848 5.33334 2.66667V11.7239L6.86194 10.1953C7.12229 9.93491 7.5444 9.93491 7.80475 10.1953C8.0651 10.4556 8.0651 10.8777 7.80475 11.1381L5.13808 13.8047C4.87773 14.0651 4.45562 14.0651 4.19527 13.8047L1.52861 11.1381C1.26826 10.8777 1.26826 10.4556 1.52861 10.1953C1.78896 9.93491 2.21107 9.93491 2.47141 10.1953L4.00001 11.7239V2.66667C4.00001 2.29848 4.29849 2 4.66668 2ZM10.8619 2.19526C11.1223 1.93491 11.5444 1.93491 11.8047 2.19526L14.4714 4.86193C14.7318 5.12228 14.7318 5.54439 14.4714 5.80474C14.2111 6.06509 13.789 6.06509 13.5286 5.80474L12 4.27614V13.3333C12 13.7015 11.7015 14 11.3333 14C10.9652 14 10.6667 13.7015 10.6667 13.3333V4.27614L9.13808 5.80474C8.87773 6.06509 8.45562 6.06509 8.19527 5.80474C7.93492 5.54439 7.93492 5.12228 8.19527 4.86193L10.8619 2.19526Z",
    fill: "currentColor"
  }))), _symbol156 || (_symbol156 = /*#__PURE__*/React.createElement("symbol", {
    id: "paint",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0H0V6H12V4H13C13.5523 4 14 4.44772 14 5V6C14 6.55228 13.5523 7 13 7H12H7C5.34315 7 4 8.34315 4 10H3.5V16H6.5V10H6C6 9.44772 6.44772 9 7 9H12H13C14.6569 9 16 7.65685 16 6V5C16 3.34315 14.6569 2 13 2H12V0Z",
    fill: "currentColor"
  }))), _symbol157 || (_symbol157 = /*#__PURE__*/React.createElement("symbol", {
    id: "paint_palette",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55544 14.6518C4.87103 15.5308 6.41775 16 8 16C10.2091 16 12 14.2091 12 12C12 10.8954 12.8954 10 14 10C15.1046 10 16 9.10457 16 8C16 6.41775 15.5308 4.87104 14.6518 3.55544C13.7727 2.23985 12.5233 1.21447 11.0615 0.608968C9.59966 0.00346649 7.99113 -0.15496 6.43928 0.153721C4.88743 0.462403 3.46197 1.22433 2.34315 2.34315C1.22433 3.46197 0.462403 4.88743 0.153722 6.43928C-0.15496 7.99113 0.00346613 9.59966 0.608967 11.0615C1.21447 12.5233 2.23985 13.7727 3.55544 14.6518ZM8.66067 2.63291C8.39677 3.27084 8.69998 4.00191 9.33791 4.26581C9.97583 4.5297 10.7069 4.22649 10.9708 3.58857C11.2347 2.95064 10.9315 2.21957 10.2936 1.95567C9.65563 1.69178 8.92456 1.99499 8.66067 2.63291ZM5.86806 4.72422C5.32056 5.14474 4.53583 5.04179 4.11531 4.49428C3.6948 3.94678 3.79775 3.16205 4.34525 2.74153C4.89276 2.32102 5.67749 2.42397 6.098 2.97147C6.51851 3.51898 6.41557 4.30371 5.86806 4.72422ZM3.45464 9.36138C4.13905 9.27096 4.62057 8.64284 4.53015 7.95843C4.43972 7.27402 3.8116 6.7925 3.12719 6.88292C2.44278 6.97334 1.96126 7.60147 2.05168 8.28588C2.1421 8.97028 2.77023 9.45181 3.45464 9.36138ZM7.99999 14C9.10456 14 9.99999 13.1046 9.99999 12C9.99999 10.8954 9.10456 10 7.99999 10C6.89542 10 5.99999 10.8954 5.99999 12C5.99999 13.1046 6.89542 14 7.99999 14ZM11.4698 7.04157C11.3794 6.35716 11.8609 5.72903 12.5453 5.63861C13.2297 5.54819 13.8579 6.02971 13.9483 6.71412C14.0387 7.39853 13.5572 8.02665 12.8728 8.11707C12.1884 8.2075 11.5603 7.72598 11.4698 7.04157Z",
    fill: "currentColor"
  }))), _symbol158 || (_symbol158 = /*#__PURE__*/React.createElement("symbol", {
    id: "panic",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1.33334C5.74749 1.33334 5.51664 1.47601 5.40372 1.70187L2.07038 8.36853C1.96705 8.57519 1.9781 8.82062 2.09957 9.01716C2.22104 9.21371 2.43562 9.33334 2.66667 9.33334H5.14615L4.01991 13.8383C3.94834 14.1246 4.07348 14.4239 4.32752 14.574C4.58156 14.7241 4.90407 14.6893 5.1203 14.4885L14.4536 5.82187C14.6545 5.63533 14.7207 5.34484 14.6205 5.08967C14.5203 4.83449 14.2741 4.66668 14 4.66668H11.1775L12.5717 2.34301C12.6952 2.13705 12.6985 1.88055 12.5801 1.67154C12.4618 1.46254 12.2402 1.33334 12 1.33334H6Z",
    fill: "currentColor"
  }))), _symbol159 || (_symbol159 = /*#__PURE__*/React.createElement("symbol", {
    id: "paragraph",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83334 5.33333C1.83334 3.49238 3.32573 2 5.16668 2H13.3333C13.7015 2 14 2.29848 14 2.66667C14 3.03486 13.7015 3.33333 13.3333 3.33333H10.6667V13.3333C10.6667 13.7015 10.3682 14 10 14C9.63182 14 9.33334 13.7015 9.33334 13.3333V3.33333H7.33334V13.3333C7.33334 13.7015 7.03487 14 6.66668 14C6.29849 14 6.00001 13.7015 6.00001 13.3333V8.66667H5.16668C3.32573 8.66667 1.83334 7.17428 1.83334 5.33333ZM6.00001 7.33333V3.33333H5.16668C4.06211 3.33333 3.16668 4.22876 3.16668 5.33333C3.16668 6.4379 4.06211 7.33333 5.16668 7.33333H6.00001Z",
    fill: "currentColor"
  }))), _symbol160 || (_symbol160 = /*#__PURE__*/React.createElement("symbol", {
    id: "parse",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 10,
    height: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1L16 3.5L12 6V1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 10,
    height: 16,
    rx: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 4,
    height: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 6,
    height: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 5,
    height: 1,
    fill: "currentColor"
  }))), _symbol161 || (_symbol161 = /*#__PURE__*/React.createElement("symbol", {
    id: "parse2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 10,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4L16 7L12 10V4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    y: 1,
    width: 10,
    height: 15,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 6,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 5,
    height: 2,
    fill: "currentColor"
  }))), _symbol162 || (_symbol162 = /*#__PURE__*/React.createElement("symbol", {
    id: "parse3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 10,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3L16 6L12 9V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 10,
    height: 16,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 7,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 5,
    height: 2,
    fill: "currentColor"
  }))), _symbol163 || (_symbol163 = /*#__PURE__*/React.createElement("symbol", {
    id: "parse4",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.5,
    width: 2,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5L16 8L12 11.5V4.5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.5,
    width: 9,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5L16 8L12 11.5V4.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    width: 10,
    height: 16,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 4,
    height: 3,
    fill: "currentColor"
  }))), _symbol164 || (_symbol164 = /*#__PURE__*/React.createElement("symbol", {
    id: "paste",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1H3C1.89543 1 1 1.89543 1 3V6H3V3H6V1ZM10 3V1H13C14.1046 1 15 1.89543 15 3V6H13V3H10ZM10 13H13V10H15V13C15 14.1046 14.1046 15 13 15H10V13ZM3 10V13H6V15H3C1.89543 15 1 14.1046 1 13V10H3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5C8.55228 5.5 9 5.94772 9 6.5V8.5H7V6.5C7 5.94772 7.44772 5.5 8 5.5ZM10.5 8.5 8 11.5 5.5 8.5H10.5Z",
    fill: "currentColor"
  }))), _symbol165 || (_symbol165 = /*#__PURE__*/React.createElement("symbol", {
    id: "path2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73244 4C3.38663 4.5978 2.74028 5 2 5C0.895431 5 0 4.10457 0 3C0 1.89543 0.895431 1 2 1C2.74028 1 3.38663 1.4022 3.73244 2H10C10.9283 2 11.8185 2.36875 12.4749 3.02513C13.1313 3.6815 13.5 4.57174 13.5 5.5C13.5 6.42826 13.1313 7.3185 12.4749 7.97487C11.8185 8.63125 10.9283 9 10 9H7C6.17158 9 5.5 9.67157 5.5 10.5C5.5 11.3284 6.17157 12 7 12H12.2676C12.6134 11.4022 13.2597 11 14 11C15.1046 11 16 11.8954 16 13C16 14.1046 15.1046 15 14 15C13.2597 15 12.6134 14.5978 12.2676 14H7C6.07174 14 5.1815 13.6313 4.52513 12.9749C3.86875 12.3185 3.5 11.4283 3.5 10.5C3.5 9.57174 3.86875 8.6815 4.52513 8.02513C5.1815 7.36875 6.07174 7 7 7H10C10.8284 7 11.5 6.32843 11.5 5.5C11.5 4.67158 10.8284 4.00001 10 4H3.73244Z",
    fill: "currentColor"
  }))), _symbol166 || (_symbol166 = /*#__PURE__*/React.createElement("symbol", {
    id: "people",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64584 8C4.93328 8.79613 4.5 9.84747 4.5 11V15H1C0.447715 15 0 14.5523 0 14V11C0 9.34315 1.34315 8 3 8H5.64584ZM7.06188 1.82086C6.70386 2.46649 6.5 3.20944 6.5 4C6.5 4.79056 6.70386 5.53351 7.06188 6.17914C6.52432 6.68796 5.7986 7 5 7C3.34315 7 2 5.65685 2 4C2 2.34315 3.34315 1 5 1C5.7986 1 6.52432 1.31204 7.06188 1.82086Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11C6 9.34315 7.34315 8 9 8H13C14.6569 8 16 9.34315 16 11V14C16 14.5523 15.5523 15 15 15H7C6.44772 15 6 14.5523 6 14V11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4,
    r: 3,
    fill: "currentColor"
  }))), _symbol167 || (_symbol167 = /*#__PURE__*/React.createElement("symbol", {
    id: "people_settings",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 4C6.5 3.20944 6.70386 2.46649 7.06188 1.82086C6.52432 1.31204 5.7986 1 5 1C3.34315 1 2 2.34315 2 4C2 4.8213 2.33003 5.56551 2.86471 6.10726C3.23233 6.03686 3.61186 6 4 6C4.91246 6 5.77735 6.20368 6.55168 6.56806C6.7356 6.4567 6.90659 6.32613 7.06188 6.17914C6.70386 5.53351 6.5 4.79056 6.5 4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C14 5.65685 12.6569 7 11 7 9.34315 7 8 5.65685 8 4 8 2.34315 9.34315 1 11 1 12.6569 1 14 2.34315 14 4ZM8.50785 8.04017C8.66798 8.01375 8.83238 8 9 8H13C14.6569 8 16 9.34315 16 11V14C16 14.5523 15.5523 15 15 15H9.19731C9.70782 14.1175 10 13.0929 10 12 10 10.4826 9.43672 9.09676 8.50785 8.04017ZM3.61759 8C3.3989 8 3.20559 8.14212 3.14035 8.35086L2.86853 9.2207C2.6127 9.32495 2.3745 9.4635 2.15964 9.63063L1.26963 9.43094C1.05624 9.38307.8365 9.47942.72715 9.66881L.34475 10.3312C.2354 10.5206.26183 10.759.40998 10.9199L1.0277 11.5906C1.00944 11.7244 1 11.8611 1 12 1 12.1389 1.00944 12.2755 1.0277 12.4094L.40998 13.0801C.26183 13.241.2354 13.4794.34475 13.6688L.72715 14.3312C.8365 14.5206 1.05624 14.6169 1.26963 14.569L2.15962 14.3694C2.37449 14.5365 2.6127 14.675 2.86853 14.7793L3.14035 15.6491C3.20559 15.8579 3.3989 16 3.61759 16H4.3824C4.6011 16 4.79441 15.8579 4.85964 15.6491L5.13146 14.7793C5.3873 14.675 5.62552 14.5365 5.84039 14.3693L6.73043 14.569C6.94382 14.6169 7.16356 14.5206 7.27291 14.3312L7.65531 13.6688C7.76466 13.4794 7.73823 13.241 7.59008 13.0801L6.9723 12.4093C6.99057 12.2755 7 12.1389 7 12 7 11.8611 6.99057 11.7245 6.9723 11.5906L7.59008 10.9199C7.73823 10.759 7.76466 10.5206 7.65531 10.3312L7.27291 9.66883C7.16356 9.47943 6.94382 9.38308 6.73043 9.43096L5.84039 9.63066C5.62551 9.46351 5.3873 9.32495 5.13147 9.2207L4.85964 8.35086C4.79441 8.14212 4.6011 8 4.3824 8H3.61759ZM4 13C4.55228 13 5 12.5523 5 12 5 11.4477 4.55228 11 4 11 3.44771 11 3 11.4477 3 12 3 12.5523 3.44771 13 4 13Z",
    fill: "currentColor"
  }))), _symbol168 || (_symbol168 = /*#__PURE__*/React.createElement("symbol", {
    id: "play_circle",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.69332 4.89333L10.6933 7.46C10.7869 7.52044 10.8638 7.60335 10.9171 7.70118C10.9704 7.799 10.9983 7.90861 10.9983 8.02C10.9983 8.13139 10.9704 8.241 10.9171 8.33882C10.8638 8.43665 10.7869 8.51956 10.6933 8.58L6.69332 11.1467C6.59268 11.2112 6.47652 11.2476 6.35701 11.2518C6.23751 11.2561 6.11907 11.2281 6.01409 11.1708C5.90911 11.1136 5.82147 11.0291 5.76034 10.9263C5.69921 10.8236 5.66686 10.7062 5.66666 10.5867V5.45333C5.66686 5.33376 5.69921 5.21643 5.76034 5.11366C5.82147 5.01088 5.90911 4.92644 6.01409 4.86918C6.11907 4.81192 6.23751 4.78395 6.35701 4.7882C6.47652 4.79245 6.59268 4.82876 6.69332 4.89333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol169 || (_symbol169 = /*#__PURE__*/React.createElement("symbol", {
    id: "points",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2C7.32843 2 8 2.67157 8 3.5C8 4.32843 7.32843 5 6.5 5C5.67157 5 5 4.32843 5 3.5C5 2.67157 5.67157 2 6.5 2ZM2.5 11C3.32843 11 4 11.6716 4 12.5C4 13.3284 3.32843 14 2.5 14C1.67157 14 1 13.3284 1 12.5C1 11.6716 1.67157 11 2.5 11ZM15 5.5C15 4.67157 14.3284 4 13.5 4C12.6716 4 12 4.67157 12 5.5C12 6.32843 12.6716 7 13.5 7C14.3284 7 15 6.32843 15 5.5ZM11.5 10C12.3284 10 13 10.6716 13 11.5C13 12.3284 12.3284 13 11.5 13C10.6716 13 10 12.3284 10 11.5C10 10.6716 10.6716 10 11.5 10Z",
    fill: "currentColor"
  }))), _symbol170 || (_symbol170 = /*#__PURE__*/React.createElement("symbol", {
    id: "predict",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12215 12.3413 1.5 13.5V16H14.5V13.5L12.8238 12.3826C11.4827 13.3977 9.81169 14 8 14 6.16391 14 4.47229 13.3814 3.12215 12.3413ZM14 6C14 9.31371 11.3137 12 8 12 4.68629 12 2 9.31371 2 6 2 2.68629 4.68629 0 8 0 11.3137 0 14 2.68629 14 6ZM8.90513 2.10375C8.35353 1.97561 7.78101 1.96605 7.22544 2.07571 6.66988 2.18536 6.14393 2.41173 5.68238 2.73984 5.22083 3.06795 4.83422 3.49032 4.5481 3.97901 4.26199 4.4677 4.0829 5.01157 4.02268 5.57464L5.15446 5.69568C5.19755 5.29284 5.32568 4.90373 5.53037 4.5541 5.73507 4.20447 6.01167 3.90229 6.34188 3.66755 6.67209 3.43281 7.04838 3.27085 7.44585 3.1924 7.84333 3.11395 8.25293 3.12079 8.64756 3.21247L8.90513 2.10375ZM5.27224 8.92564C4.77945 8.46617 4.4107 7.88968 4.20021 7.24965L5.28148 6.89405C5.43207 7.35195 5.69589 7.7644 6.04845 8.09312L5.27224 8.92564Z",
    fill: "currentColor"
  }))), _symbol171 || (_symbol171 = /*#__PURE__*/React.createElement("symbol", {
    id: "preparation",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1L6 7V13L10 16V7L16 1V0H0V1Z",
    fill: "currentColor"
  }))), _symbol172 || (_symbol172 = /*#__PURE__*/React.createElement("symbol", {
    id: "properties",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33333V4C12.6667 3.46957 12.456 2.96086 12.0809 2.58579C11.7058 2.21071 11.1971 2 10.6667 2H4.66666C4.13623 2 3.62752 2.21071 3.25245 2.58579C2.87738 2.96086 2.66666 3.46957 2.66666 4V12C2.66666 12.5304 2.87738 13.0391 3.25245 13.4142C3.62752 13.7893 4.13623 14 4.66666 14H7M5.33333 10H6M5.33333 4.66667H10M5.33333 7.33333H7.33333M12.7473 13.414C12.5628 13.605 12.3421 13.7574 12.0981 13.8622C11.8541 13.967 11.5917 14.0222 11.3261 14.0245C11.0606 14.0268 10.7972 13.9762 10.5514 13.8756C10.3056 13.7751 10.0823 13.6266 9.89454 13.4388C9.70676 13.251 9.55825 13.0277 9.45769 12.7819C9.35713 12.5361 9.30652 12.2728 9.30883 12.0072C9.31114 11.7416 9.36631 11.4792 9.47113 11.2352C9.57595 10.9912 9.72831 10.7705 9.91933 10.586C10.2965 10.2217 10.8017 10.0201 11.3261 10.0247C11.8505 10.0292 12.3522 10.2395 12.723 10.6104C13.0938 10.9812 13.3041 11.4828 13.3087 12.0072C13.3132 12.5316 13.1116 13.0368 12.7473 13.414ZM12.7473 13.414L14 14.6667",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol173 || (_symbol173 = /*#__PURE__*/React.createElement("symbol", {
    id: "quote",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00131 2.00002L14.0013 2C14.1781 2 14.3477 2.07024 14.4727 2.19526C14.5977 2.32029 14.668 2.48986 14.668 2.66667V12.0238C14.668 12.392 14.3695 12.6905 14.0013 12.6905L10.2505 12.6905L8.42378 14.2039C8.17595 14.4092 7.81683 14.4082 7.57019 14.2014L5.76772 12.6905H2.00131C1.8245 12.6905 1.65493 12.6203 1.5299 12.4953C1.40488 12.3702 1.33464 12.2007 1.33464 12.0238V2.66668C1.33464 2.29849 1.63312 2.00002 2.00131 2.00002ZM5 6.68875C5 5.94017 5.60385 5.33333 6.34873 5.33333C7.09086 5.33333 7.693 5.93571 7.69743 6.68047C7.73631 7.44669 7.57472 8.00401 7.25842 8.45341C6.95069 8.89063 6.51218 9.20026 6.06541 9.49959C5.92786 9.59174 5.74107 9.55368 5.64955 9.41572C5.55803 9.27775 5.59536 9.09051 5.7329 8.99836C6.18527 8.69528 6.53352 8.44016 6.76903 8.10554C6.80635 8.05252 6.84127 7.99681 6.87341 7.93777C6.71213 8.00628 6.53483 8.04416 6.34873 8.04416C5.60385 8.04416 5 7.43732 5 6.68875ZM8.29688 6.68875C8.29688 5.94017 8.90073 5.33333 9.64561 5.33333C10.3877 5.33333 10.9899 5.93571 10.9943 6.68047C11.0332 7.44669 10.8716 8.00401 10.5553 8.45341C10.2476 8.89063 9.80906 9.20026 9.36229 9.49959C9.22474 9.59174 9.03795 9.55368 8.94643 9.41572C8.85491 9.27775 8.89224 9.09051 9.02978 8.99836C9.48215 8.69528 9.8304 8.44016 10.0659 8.10554C10.1032 8.05252 10.1382 7.99681 10.1703 7.93777C10.009 8.00628 9.83171 8.04416 9.64561 8.04416C8.90073 8.04416 8.29688 7.43732 8.29688 6.68875Z",
    fill: "currentColor"
  }))), _symbol174 || (_symbol174 = /*#__PURE__*/React.createElement("symbol", {
    id: "random",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07324 7.24896C8.38127 6.9971 8.02449 6.23198 8.27634 5.54001L9.41641 2.4077C9.66827 1.71573 10.4334 1.35895 11.1254 1.6108L14.2577 2.75087C14.9496 3.00273 15.3064 3.76785 15.0546 4.45982L13.9145 7.59213C13.6626 8.2841 12.8975 8.64088 12.2055 8.38902L9.07324 7.24896ZM11.4387 5.62643C11.7847 5.75236 12.1672 5.57397 12.2931 5.22799 12.4191 4.882 12.2407 4.49944 11.8947 4.37351 11.5487 4.24758 11.1661 4.42597 11.0402 4.77196 10.9143 5.11794 11.0927 5.50051 11.4387 5.62643ZM1.33602 7.32965C.66863 7.64085.37989 8.43416.6911 9.10155L2.66332 13.331C2.97452 13.9984 3.76783 14.2871 4.43522 13.9759L8.66465 12.0037C9.33204 11.6925 9.62078 10.8992 9.30957 10.2318L7.33735 6.00235C7.02615 5.33496 6.23284 5.04622 5.56545 5.35743L1.33602 7.32965ZM4.27401 8.90122C4.42962 9.23491 4.28525 9.63157 3.95155 9.78717 3.61786 9.94277 3.22121 9.7984 3.0656 9.46471 2.91 9.13102 3.05437 8.73436 3.38806 8.57876 3.72176 8.42316 4.11841 8.56753 4.27401 8.90122ZM6.61041 10.7546C6.9441 10.599 7.08847 10.2024 6.93287 9.86867 6.77726 9.53497 6.38061 9.3906 6.04692 9.54621 5.71322 9.70181 5.56885 10.0985 5.72446 10.4322 5.88006 10.7659 6.27671 10.9102 6.61041 10.7546Z",
    fill: "currentColor"
  }))), _symbol175 || (_symbol175 = /*#__PURE__*/React.createElement("symbol", {
    id: "recent",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C2.38419e-07 6.14915 0.641755 4.35557 1.81592 2.92485C2.99008 1.49413 4.624 0.514797 6.43928 0.153715C8.25456 -0.207366 10.1389 0.0721462 11.7712 0.944627C13.4035 1.81711 14.6827 3.22857 15.391 4.93853C16.0993 6.64848 16.1928 8.55113 15.6555 10.3223C15.1183 12.0934 13.9835 13.6235 12.4446 14.6518C10.9056 15.68 9.05779 16.1429 7.21587 15.9615C5.37394 15.7801 3.65189 14.9656 2.34315 13.6569L3.76867 12.2313C4.74761 13.2103 6.0357 13.8195 7.41347 13.9552C8.79123 14.0909 10.1734 13.7447 11.3245 12.9755C12.4756 12.2064 13.3245 11.0619 13.7263 9.73706C14.1282 8.41224 14.0583 6.98907 13.5285 5.71002C12.9987 4.43097 12.0418 3.3752 10.8208 2.72258C9.59988 2.06996 8.19041 1.86089 6.83258 2.13098C5.47475 2.40107 4.25258 3.13361 3.37431 4.20379C2.49603 5.27397 2.016 6.61557 2.016 8H4L1 12L-2 8H0ZM8 4C7.44771 4 7 4.44771 7 5V8C7 8.37712 7.20876 8.70549 7.51702 8.87584L9.77767 10.181C10.256 10.4572 10.8675 10.2933 11.1437 9.815C11.4198 9.33671 11.256 8.72512 10.7777 8.44897L9 7.42264V5C9 4.44771 8.55228 4 8 4Z",
    fill: "currentColor"
  }))), _symbol176 || (_symbol176 = /*#__PURE__*/React.createElement("symbol", {
    id: "redo",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1953 1.52859C10.4556 1.26824 10.8777 1.26824 11.1381 1.52859L13.1381 3.52859C13.3984 3.78894 13.3984 4.21105 13.1381 4.4714L11.1381 6.4714C10.8777 6.73175 10.4556 6.73175 10.1953 6.4714C9.93492 6.21105 9.93492 5.78894 10.1953 5.52859L11.0572 4.66667H6.33334C4.3083 4.66667 2.66668 6.30829 2.66668 8.33333C2.66668 10.3584 4.3083 12 6.33334 12H11.3333C11.7015 12 12 12.2985 12 12.6667C12 13.0349 11.7015 13.3333 11.3333 13.3333H6.33334C3.57192 13.3333 1.33334 11.0948 1.33334 8.33333C1.33334 5.57191 3.57192 3.33333 6.33334 3.33333H11.0572L10.1953 2.4714C9.93492 2.21105 9.93492 1.78894 10.1953 1.52859Z",
    fill: "currentColor"
  }))), _symbol177 || (_symbol177 = /*#__PURE__*/React.createElement("symbol", {
    id: "refresh",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 8C12.6665 7.63333 12.9665 7.33333 13.3332 7.33333H13.3398C13.7065 7.33333 14.0065 7.63333 14.0065 8 14.0065 11.3133 11.3198 14 8.00651 14 6.48651 14 5.07984 13.4267 4.00651 12.4867V13.3333C4.00651 13.7 3.70651 14 3.33984 14 2.97318 14 2.67318 13.7 2.67318 13.3333V10.6667C2.67318 10.6533 2.67651 10.64 2.67984 10.6267 2.68318 10.6133 2.68651 10.6 2.68651 10.5867 2.69318 10.54 2.69984 10.5 2.71318 10.4533 2.7231 10.4236 2.73673 10.3975 2.75129 10.3696 2.75629 10.36 2.7614 10.3502 2.76651 10.34 2.7734 10.3297 2.77984 10.3198 2.78607 10.3102 2.80395 10.2828 2.82007 10.2581 2.83984 10.2333 2.86651 10.1933 2.89984 10.1667 2.93984 10.14 2.94833 10.1343 2.95562 10.1263 2.96324 10.1179 2.97356 10.1064 2.98449 10.0943 2.99984 10.0867 3.01318 10.0733 3.02651 10.0733 3.03984 10.0733 3.06901 10.0588 3.09817 10.0513 3.12992 10.0431 3.14171 10.0401 3.15387 10.0369 3.16651 10.0333 3.20651 10.02 3.24651 10.0067 3.29318 10.0067 3.30651 10.0067 3.33318 10 3.33318 10H5.99984C6.36651 10 6.66651 10.3 6.66651 10.6667 6.66651 11.0333 6.36651 11.3333 5.99984 11.3333H4.69984C5.55318 12.1533 6.72651 12.6667 7.99984 12.6667 10.5798 12.6667 12.6665 10.58 12.6665 8ZM8 3.33333C5.42 3.33333 3.33333 5.42 3.33333 8 3.33333 8.36667 3.03333 8.66667 2.66667 8.66667 2.3 8.66667 2 8.36667 2 8 2 4.68667 4.68667 2 7.99333 2 9.52 2 10.9267 2.58 12 3.52V2.66667C12 2.3 12.3 2 12.6667 2 13.0333 2 13.3333 2.3 13.3333 2.66667V5.34C13.3333 5.38667 13.32 5.43333 13.3067 5.48 13.3 5.49333 13.3 5.51333 13.3 5.52667 13.28 5.59333 13.2533 5.65333 13.2133 5.70667 13.2067 5.71333 13.2017 5.72167 13.1967 5.73 13.1917 5.73833 13.1867 5.74667 13.18 5.75333 13.14 5.8 13.0867 5.84 13.0333 5.88 13.0286 5.88472 13.0247 5.88945 13.0211 5.89387 13.0144 5.90194 13.0086 5.90903 13 5.91333 12.9933 5.92 12.9867 5.92 12.98 5.92 12.9333 5.94667 12.88 5.96 12.8267 5.97333 12.8124 5.97571 12.799 5.97893 12.7858 5.9821 12.7621 5.98781 12.7391 5.99333 12.7133 5.99333 12.7 5.99333 12.6733 6 12.6733 6H10.0067C9.64 6 9.34 5.7 9.34 5.33333 9.34 4.96667 9.64 4.66667 10.0067 4.66667H11.3C10.4467 3.84667 9.27333 3.33333 8 3.33333Z",
    fill: "currentColor"
  }))), _symbol178 || (_symbol178 = /*#__PURE__*/React.createElement("symbol", {
    id: "remove-textstyle",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5001 2.22559C1.7437 1.9495 2.16499 1.92317 2.44107 2.16678L13.7744 12.1668C14.0505 12.4104 14.0768 12.8317 13.8332 13.1077C13.5896 13.3838 13.1683 13.4102 12.8922 13.1666L7.90898 8.76957L7.32817 13.416C7.2825 13.7814 6.94931 14.0405 6.58396 13.9949C6.21862 13.9492 5.95947 13.616 6.00514 13.2506L6.68671 7.79806C6.69061 7.76683 6.69662 7.73639 6.70456 7.70684L1.55891 3.16656C1.28282 2.92296 1.25649 2.50167 1.5001 2.22559ZM5.33332 2.66667C5.33332 2.29848 5.6318 2 5.99999 2H12.6667C13.0348 2 13.3333 2.29848 13.3333 2.66667C13.3333 3.03486 13.0348 3.33333 12.6667 3.33333H8.58851L8.41151 4.74936C8.36584 5.1147 8.03265 5.37385 7.6673 5.32819C7.30195 5.28252 7.0428 4.94932 7.08847 4.58398L7.2448 3.33333H5.99999C5.6318 3.33333 5.33332 3.03486 5.33332 2.66667Z",
    fill: "currentColor"
  }))), _symbol179 || (_symbol179 = /*#__PURE__*/React.createElement("symbol", {
    id: "restore",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.685 8C12.685 5.42267 10.5957 3.33333 8.01833 3.33333C6.70233 3.33333 5.74986 3.78632 4.82737 4.66667H6.00009C6.36827 4.66667 6.66673 4.96515 6.66673 5.33333C6.66673 5.70152 6.36827 6 6.00009 6H4.00009C3.26371 6 2.66675 5.40305 2.66675 4.66667V2.66667C2.66675 2.29848 2.96523 2 3.33342 2C3.70161 2 4.00009 2.29848 4.00009 2.66667V3.61534C5.08153 2.6146 6.31734 2 8.01833 2C11.332 2 14.0183 4.68629 14.0183 8C14.0183 11.3137 11.332 14 8.01833 14C5.40483 14 3.18325 12.3294 2.3599 9.99993C2.2372 9.6528 2.41915 9.27193 2.76629 9.1492C3.11344 9.02653 3.49432 9.20847 3.61701 9.5556C4.25797 11.3691 5.98746 12.6667 8.01833 12.6667C10.5957 12.6667 12.685 10.5773 12.685 8Z",
    fill: "currentColor"
  }))), _symbol180 || (_symbol180 = /*#__PURE__*/React.createElement("symbol", {
    id: "right_panel",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_274)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11884 3.65909e-07H10.8812C11.5967 -1.06242e-05 12.1872 -1.9696e-05 12.6683 0.0392844C13.1679 0.0801068 13.6272 0.167719 14.0587 0.387533C14.7276 0.728417 15.2716 1.27235 15.6124 1.94137C15.8323 2.37277 15.9199 2.83207 15.9607 3.33172C16 3.81276 16 4.40331 16 5.11883V10.8812C16 11.5967 16 12.1872 15.9607 12.6683C15.9199 13.1679 15.8323 13.6272 15.6124 14.0587C15.2716 14.7276 14.7276 15.2716 14.0587 15.6124C13.6272 15.8323 13.1679 15.9199 12.6683 15.9607C12.1872 16 11.5967 16 10.8812 16H5.11883C4.40331 16 3.81277 16 3.33172 15.9607C2.83207 15.9199 2.37277 15.8323 1.94137 15.6124C1.27235 15.2716 0.728417 14.7276 0.387533 14.0587C0.167719 13.6272 0.0801068 13.1679 0.0392844 12.6683C-1.96927e-05 12.1872 -1.06242e-05 11.5967 3.6591e-07 10.8812V5.11884C-1.06242e-05 4.40332 -1.9696e-05 3.81277 0.0392844 3.33172C0.0801068 2.83207 0.167719 2.37277 0.387533 1.94137C0.728417 1.27235 1.27235 0.728417 1.94137 0.387533C2.37277 0.167719 2.83207 0.0801068 3.33172 0.0392844C3.81277 -1.96927e-05 4.40331 -1.06242e-05 5.11884 3.65909e-07ZM10.6667 11.5556C10.6667 12.0465 11.0646 12.4444 11.5556 12.4444C12.0465 12.4444 12.4444 12.0465 12.4444 11.5556V4.44444C12.4444 3.95353 12.0465 3.55556 11.5556 3.55556C11.0646 3.55556 10.6667 3.95353 10.6667 4.44444V11.5556Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol181 || (_symbol181 = /*#__PURE__*/React.createElement("symbol", {
    id: "right_side_panel",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 3C0 1.34315 1.34315 0 3 0H8V16H3C1.34315 16 0 14.6569 0 13V3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0H9V16H13C14.6569 16 16 14.6569 16 13V3C16 1.34315 14.6569 0 13 0ZM14 4H11V5H14V4ZM14 6H11V7H14V6ZM11 8H14V9H11V8Z",
    fill: "currentColor"
  }))), _symbol182 || (_symbol182 = /*#__PURE__*/React.createElement("symbol", {
    id: "robot",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8H13V12C13 14.2091 11.2091 16 9 16H7C4.79086 16 3 14.2091 3 12V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8.5,
    width: 1,
    height: 4.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8.5,
    width: 1,
    height: 4.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0H7.5V1.02469C4.97334 1.27555 3 3.40733 3 6V7H13V6C13 3.40733 11.0267 1.27555 8.5 1.02469V0ZM7 3.5H5.5V5H7V3.5ZM9 3.5H10.5V5H9V3.5Z",
    fill: "currentColor"
  }))), _symbol183 || (_symbol183 = /*#__PURE__*/React.createElement("symbol", {
    id: "root",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    fill: "currentColor"
  })))), _symbol184 || (_symbol184 = /*#__PURE__*/React.createElement("symbol", {
    id: "row_add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5H1V9H5V5ZM15 5H11V9H15V5ZM7 10H9V12H11V14H9V16H7V14H5V12H7V10ZM6 5H10V9H6V5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0H1V4H5V0ZM6 0H10V4H6V0ZM11 0H15V4H11V0Z",
    fill: "currentColor"
  }))), _symbol185 || (_symbol185 = /*#__PURE__*/React.createElement("symbol", {
    id: "scissors",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7699 12.8559C14.5352 13.2977 15.5137 13.0355 15.9555 12.2703C16.066 12.0789 16.0004 11.8343 15.8091 11.7238L15.4786 11.533L10.3136 8.55098L8.31355 9.70568L13.4394 12.6651L13.444 12.6677L13.7699 12.8559ZM5.76182 10.0243L4.96309 10.4855C5.07499 10.6039 5.17484 10.7358 5.26033 10.8807C5.96158 12.0689 5.43125 13.6806 4.07579 14.4806C2.72033 15.2805 1.05303 14.9658 0.35178 13.7776C-0.349474 12.5894 0.180864 10.9777 1.53632 10.1777C1.55931 10.1641 1.58238 10.1509 1.60553 10.138L1.57328 10.1332L2.86874 9.38524L5.31364 7.97368L2.82654 6.53775L1.53108 5.7898L1.56333 5.78501C1.54017 5.77208 1.5171 5.75884 1.49412 5.74528C0.138658 4.94531 -0.39168 3.33358 0.309574 2.14538C1.01083 0.957183 2.67812 0.642459 4.03358 1.44243C5.38904 2.24239 5.91938 3.85412 5.21812 5.04232C5.13263 5.18718 5.03278 5.31905 4.92089 5.43751L7.31365 6.81897L13.4816 3.25791L13.4862 3.25527L13.8121 3.0671C14.5774 2.62527 15.5559 2.88747 15.9977 3.65274C16.1082 3.84405 16.0427 4.08869 15.8513 4.19915L15.5208 4.38996L11.9577 6.44716L11.9576 6.44708L5.76177 10.0243L5.76182 10.0243ZM3.92632 4.27992C4.11529 3.95974 4.07827 3.21056 3.27118 2.73423C2.46409 2.2579 1.79034 2.5876 1.60138 2.90778C1.41241 3.22796 1.44942 3.97714 2.25651 4.45348C3.0636 4.92981 3.73736 4.6001 3.92632 4.27992ZM3.96853 11.6431C4.15749 11.9632 4.12048 12.7124 3.31339 13.1888C2.5063 13.6651 1.83255 13.3354 1.64358 13.0152C1.45462 12.695 1.49163 11.9458 2.29872 11.4695C3.10581 10.9932 3.77956 11.3229 3.96853 11.6431Z",
    fill: "currentColor"
  }))), _symbol186 || (_symbol186 = /*#__PURE__*/React.createElement("symbol", {
    id: "select",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 2.66666H2.66667V3.99999M12 2.66666H13.3333V3.99999M2.66667 12V13.3333H4M12 13.3333H13.3333V12M7 2.66666H9M13.3333 6.99999V8.99999M9 13.3333H7M2.66667 8.99999V6.99999",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square"
  }))), _symbol187 || (_symbol187 = /*#__PURE__*/React.createElement("symbol", {
    id: "select_column",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11L12 15L16 15L16 11L12 11ZM12 10L12 6L16 6L16 10L12 10ZM12 5L12 1L16 1L16 5L12 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15L-1.74846e-07 11L4 11L4 15L0 15ZM-2.18557e-07 10L-3.93402e-07 6L4 6L4 10L-2.18557e-07 10ZM-6.11959e-07 1L-4.37114e-07 5L4 5L4 1L-6.11959e-07 1ZM5 1L5 5L9 5L9 1L5 1ZM5 6L5 10L9 10L9 6L5 6ZM5 11L5 15L9 15L9 11L5 11Z",
    fill: "currentColor"
  }))), _symbol188 || (_symbol188 = /*#__PURE__*/React.createElement("symbol", {
    id: "select_row",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12H1V16H5V12ZM6 12H10V16H6V12ZM11 12H15V16H11V12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0H5V4H1V0ZM6 0H10V4H6V0ZM15 0H11V4H15V0ZM15 5H11V9H15V5ZM10 5H6V9H10V5ZM5 5H1V9H5V5Z",
    fill: "currentColor"
  }))), _symbol189 || (_symbol189 = /*#__PURE__*/React.createElement("symbol", {
    id: "sessions",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1839 8.76473C11.8328 8.36387 13.673 9.19173 14.5315 11.2483C14.9783 12.3188 14.0151 13.3333 12.8551 13.3333H11.3345M7.00114 4.66667C7.00114 5.77123 6.10573 6.66667 5.00116 6.66667C3.8966 6.66667 3.00116 5.77123 3.00116 4.66667C3.00116 3.5621 3.8966 2.66667 5.00116 2.66667C6.10573 2.66667 7.00114 3.5621 7.00114 4.66667ZM13.0011 4.66667C13.0011 5.77123 12.1057 6.66667 11.0011 6.66667C9.8966 6.66667 9.00114 5.77123 9.00114 4.66667C9.00114 3.5621 9.8966 2.66667 11.0011 2.66667C12.1057 2.66667 13.0011 3.5621 13.0011 4.66667ZM6.8552 13.3333H3.14711C1.98716 13.3333 1.02406 12.3179 1.47105 11.2475C2.9081 7.8064 7.0942 7.8064 8.53127 11.2475C8.97827 12.3179 8.01514 13.3333 6.8552 13.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol190 || (_symbol190 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99997 0C6.44769 0 5.99997 0.447715 5.99997 1V2.34142C5.29777 2.58962 4.65557 2.96482 4.10096 3.43942L2.93788 2.76792C2.45959 2.49178 1.848 2.65566 1.57186 3.13395L0.571859 4.866C0.295716 5.34429 0.459591 5.95588 0.937884 6.23202L2.10005 6.903C2.03434 7.25866 2 7.62532 2 8C2 8.37467 2.03434 8.74132 2.10005 9.09697L0.937881 9.76794C0.459588 10.0441 0.295713 10.6557 0.571855 11.134L1.57186 12.866C1.848 13.3443 2.45959 13.5082 2.93788 13.232L4.10094 12.5606C4.65556 13.0352 5.29779 13.4104 6.00002 13.6586V15C6.00002 15.5523 6.44773 16 7.00002 16H9.00002C9.5523 16 10 15.5523 10 15V13.6586C10.7022 13.4104 11.3445 13.0352 11.8991 12.5605L13.0622 13.232C13.5405 13.5082 14.1521 13.3443 14.4282 12.866L15.4282 11.134C15.7044 10.6557 15.5405 10.0441 15.0622 9.76794L13.9 9.09692C13.9657 8.74129 14 8.37465 14 8C14 7.62534 13.9657 7.2587 13.9 6.90306L15.0622 6.23205C15.5405 5.95591 15.7043 5.34432 15.4282 4.86603L14.4282 3.13397C14.1521 2.65568 13.5405 2.49181 13.0622 2.76795L11.8991 3.43946C11.3444 2.96483 10.7022 2.58961 9.99997 2.3414V1C9.99997 0.447715 9.55226 0 8.99997 0H6.99997ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    fill: "currentColor"
  }))), _symbol191 || (_symbol191 = /*#__PURE__*/React.createElement("symbol", {
    id: "shift_key",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50001 8.49997V12.5H9.50001V8.49997H11.6944L8.00001 4.27785L4.30566 8.49997H6.50001ZM7.62372 2.43001C7.82293 2.20235 8.17709 2.20235 8.3763 2.43001L14.2744 9.17072C14.5573 9.49401 14.3277 9.99997 13.8981 9.99997H11V14H5.00001V9.99997H2.10189C1.67231 9.99997 1.44273 9.49401 1.72561 9.17071L7.62372 2.43001Z",
    fill: "currentColor"
  }))), _symbol192 || (_symbol192 = /*#__PURE__*/React.createElement("symbol", {
    id: "shortcut",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    y: 16,
    width: 16,
    height: 16,
    rx: 3,
    transform: "rotate(-90 0 16)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13L5 9.65L11 6.4L11 3",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7L4 3L6 3L6 6L4 7Z",
    fill: "currentColor"
  }))), _symbol193 || (_symbol193 = /*#__PURE__*/React.createElement("symbol", {
    id: "shortcut2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10L2.38281 10L4.38672 6L11.6147 6L13.6206 10L16 10",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11L6 9L10 9L11 11L5 11Z",
    fill: "currentColor"
  }))), _symbol194 || (_symbol194 = /*#__PURE__*/React.createElement("symbol", {
    id: "shortcut3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10L3.38 10L6.44 4L16 4",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11 7 9 12 9 12 11 6 11ZM12 7 16 10 12 13 12 7Z",
    fill: "currentColor"
  }))), _symbol195 || (_symbol195 = /*#__PURE__*/React.createElement("symbol", {
    id: "show_all",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0H2C0.895431 0 0 0.895431 0 2V6H2V2H6V0ZM10 2V0H14C15.1046 0 16 0.895431 16 2V6H14V2H10ZM10 14H14V10H16V14C16 15.1046 15.1046 16 14 16H10V14ZM2 10V14H6V16H2C0.895431 16 0 15.1046 0 14V10H2Z",
    fill: "currentColor"
  }))), _symbol196 || (_symbol196 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3 8 7 10 7 10 14 12 14 12 7 14 7 11 3ZM5 14 8 10 6 10 6 3 4 3 4 10 2 10 5 14Z",
    fill: "currentColor"
  }))), _symbol197 || (_symbol197 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort_ascending",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3L8 7H10V14H12V7H14L11 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14L8 10H6V3H4V10H2L5 14Z",
    fill: "currentColor"
  }))), _symbol198 || (_symbol198 = /*#__PURE__*/React.createElement("symbol", {
    id: "sort_descending",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3L8 7H10V14H12V7H14L11 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14L8 10H6V3H4V10H2L5 14Z",
    fill: "currentColor"
  }))), _symbol199 || (_symbol199 = /*#__PURE__*/React.createElement("symbol", {
    id: "split",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 1.33333C8.3682 1.33333 8.66668 1.63181 8.66668 2V14C8.66668 14.3682 8.3682 14.6667 8.00001 14.6667C7.63182 14.6667 7.33334 14.3682 7.33334 14V1.99999C7.33334 1.63181 7.63182 1.33333 8.00001 1.33333ZM1.33334 3.33333C1.33334 2.96514 1.63182 2.66666 2.00001 2.66666H6.00001V13.3333H2.00001C1.63182 13.3333 1.33334 13.0349 1.33334 12.6667V3.33333ZM10 2.66666H14C14.3682 2.66666 14.6667 2.96514 14.6667 3.33333V12.6667C14.6667 13.0349 14.3682 13.3333 14 13.3333H10V2.66666Z",
    fill: "currentColor"
  }))), _symbol200 || (_symbol200 = /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0L10.1019 5.10696L15.6085 5.52786L11.401 9.10504L12.7023 14.4721L8 11.576L3.29772 14.4721L4.59902 9.10504L0.391548 5.52786L5.89808 5.10696L8 0Z",
    fill: "#FA951F"
  }))), _symbol201 || (_symbol201 = /*#__PURE__*/React.createElement("symbol", {
    id: "stop_circle",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 7C6.33334 6.63181 6.63182 6.33333 7.00001 6.33333H9.00001C9.3682 6.33333 9.66668 6.63181 9.66668 7V9C9.66668 9.36819 9.3682 9.66667 9.00001 9.66667H7.00001C6.63182 9.66667 6.33334 9.36819 6.33334 9V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 2.66667C5.05449 2.66667 2.66668 5.05448 2.66668 8C2.66668 10.9455 5.05449 13.3333 8.00001 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 8C13.3333 5.05448 10.9455 2.66667 8.00001 2.66667ZM1.33334 8C1.33334 4.3181 4.31811 1.33333 8.00001 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8Z",
    fill: "currentColor"
  }))), _symbol202 || (_symbol202 = /*#__PURE__*/React.createElement("symbol", {
    id: "strike-through",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.69175 2.55728C5.41696 1.82159 6.51315 1.33333 7.99986 1.33333 9.55614 1.33333 10.5999 1.8701 11.2725 2.5826 11.9259 3.2747 12.1745 4.07409 12.2695 4.53084L12.4053 5.18352 11.1 5.45518 10.9641 4.8025C10.8965 4.47766 10.7238 3.94372 10.303 3.49787 9.90136 3.07245 9.218 2.66667 7.99986 2.66667 6.8199 2.66667 6.08276 3.04546 5.6413 3.4933 5.18804 3.95311 4.99986 4.53181 4.99986 5 4.99986 5.39021 5.0896 5.67389 5.22448 5.89482 5.3621 6.12026 5.5696 6.31747 5.85727 6.49646 6.44126 6.85984 7.24094 7.0849 8.17063 7.33333H14.6667V8.66667H1.33334V7.33333H4.73993C4.4895 7.12682 4.26519 6.88237 4.08644 6.58955 3.81116 6.13861 3.66653 5.60979 3.66653 5 3.66653 4.20229 3.97835 3.28099 4.69175 2.55728ZM10.8711 10H12.3502C12.449 10.3053 12.4999 10.6384 12.4999 11 12.4999 12.6679 10.9999 14.6667 7.99986 14.6667 6.44439 14.6667 5.36366 14.1316 4.63778 13.4436 3.9276 12.7705 3.59623 11.9895 3.4515 11.5361L3.24877 10.901 4.51895 10.4955 4.72169 11.1306C4.82646 11.4588 5.06451 12.011 5.55498 12.4759 6.02976 12.9259 6.78091 13.3333 7.99986 13.3333 10.3331 13.3333 11.1665 11.8639 11.1665 11 11.1665 10.6098 11.0768 10.3261 10.9419 10.1052 10.9201 10.0694 10.8965 10.0344 10.8711 10Z",
    fill: "currentColor"
  }))), _symbol203 || (_symbol203 = /*#__PURE__*/React.createElement("symbol", {
    id: "system",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.16667C2 2.97005 2.97004 2 4.16666 2H11.8333C13.0299 2 14 2.97005 14 4.16667V10.6667H14.8333C15.1095 10.6667 15.3333 10.8905 15.3333 11.1667V11.8333C15.3333 13.0299 14.3633 14 13.1667 14H2.83333C1.63671 14 0.666664 13.0299 0.666664 11.8333V11.1667C0.666664 10.8905 0.890524 10.6667 1.16666 10.6667H2V4.16667ZM1.66666 11.6667V11.8333C1.66666 12.4777 2.189 13 2.83333 13H13.1667C13.811 13 14.3333 12.4777 14.3333 11.8333V11.6667H1.66666Z",
    fill: "currentColor"
  }))), _symbol204 || (_symbol204 = /*#__PURE__*/React.createElement("symbol", {
    id: "table",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5H4V7.5H8V4.5ZM8 8.5H4V11.5H8V8.5ZM8 12.5H4V15.5H8V12.5ZM12 4.5H9V7.5H12V4.5ZM12 8.5H9V11.5H12V8.5ZM12 12.5H9V15.5H12V12.5ZM0 4.5H3V15.5H2C.89543 15.5 0 14.6046 0 13.5V4.5ZM0 2.5C0 1.39543.89543.5 2 .5H3V3.5H0V2.5ZM4 .5H14C15.1046.5 16 1.39543 16 2.5V3.5H4V.5ZM16 4.5H13V7.5H16V4.5ZM16 8.5H13V11.5H16V8.5ZM13 12.5H16V13.5C16 14.6046 15.1046 15.5 14 15.5H13V12.5Z",
    fill: "currentColor"
  }))), _symbol205 || (_symbol205 = /*#__PURE__*/React.createElement("symbol", {
    id: "table_clean",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.74846e-07 11L0 15L4 15L4 11L-1.74846e-07 11ZM-3.93402e-07 6L-2.18557e-07 10L4 10L4 6L-3.93402e-07 6ZM-4.37114e-07 5L-6.11959e-07 1L4 1L4 5L-4.37114e-07 5ZM5 5L5 1L9 1L9 5L5 5ZM5 10L5 6L9 6L9 6.04559L5.04559 10L5 10ZM5 12.6823L5 15L7.31768 15L5 12.6823Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.163 12.7782 8.62749 9.24263 12.163 5.7071C12.5535 5.31658 13.1867 5.31658 13.5772 5.7071L15.6986 7.82842C16.0891 8.21894 16.0891 8.85211 15.6986 9.24263L12.163 12.7782ZM10.7488 14.1924C10.3583 14.5829 9.7251 14.5829 9.33458 14.1924L7.21326 12.0711C6.82274 11.6806 6.82274 11.0474 7.21326 10.6569L7.92037 9.94976 11.4559 13.4853 10.7488 14.1924Z",
    fill: "currentColor"
  }))), _symbol206 || (_symbol206 = /*#__PURE__*/React.createElement("symbol", {
    id: "table_edit",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 3H16V7H12V3ZM12 8H16V12H12V8ZM5 3H6V7H5V3ZM10 3H11V7H10V3ZM10 8H11V12H10V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0H9V15H7V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 0H11V2H5V0ZM5 13H11V15H5V13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5 8H6V12H5V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    y: 3,
    width: 4,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    y: 8,
    width: 4,
    height: 4,
    fill: "currentColor"
  }))), _symbol207 || (_symbol207 = /*#__PURE__*/React.createElement("symbol", {
    id: "table_from_columns",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 5 11 1 15 1 15 5 11 5ZM11 10 11 6 15 6 15 10 11 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 11,
    y: 15,
    width: 4,
    height: 4,
    transform: "rotate(-90 11 15)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5L1 1L5 1L5 5L1 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6 5L6 1L10 1L10 5L6 5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10L1 6L5 6L5 10L1 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6 10L6 6L10 6L10 10L6 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 4,
    height: 4,
    transform: "rotate(-90 1 15)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 6,
    y: 15,
    width: 4,
    height: 4,
    transform: "rotate(-90 6 15)",
    fill: "currentColor"
  }))), _symbol208 || (_symbol208 = /*#__PURE__*/React.createElement("symbol", {
    id: "table_from_rows",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 11H15V15H11V11ZM6 11H10V15H6V11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 1,
    y: 11,
    width: 4,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1H15V5H11V1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11 6H15V10H11V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1H10V5H6V1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M6 6H10V10H6V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 4,
    height: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 1,
    y: 6,
    width: 4,
    height: 4,
    fill: "currentColor"
  }))), _symbol209 || (_symbol209 = /*#__PURE__*/React.createElement("symbol", {
    id: "tag",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4C16 2.89543 15.1045 2 14 2H5.87978C5.31917 2 4.78429 2.23529 4.40547 2.64855L0.738803 6.64855C0.0378811 7.41319 0.0378816 8.58681 0.738804 9.35145L4.40547 13.3514C4.78429 13.7647 5.31917 14 5.87978 14H14C15.1045 14 16 13.1046 16 12V4ZM5.5 9.5C6.32842 9.5 7 8.82843 7 8C7 7.17157 6.32842 6.5 5.5 6.5C4.67157 6.5 4 7.17157 4 8C4 8.82843 4.67157 9.5 5.5 9.5Z",
    fill: "currentColor"
  }))), _symbol210 || (_symbol210 = /*#__PURE__*/React.createElement("symbol", {
    id: "temp",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.00001C2.38419e-07 6.14917 0.641755 4.35559 1.81592 2.92487C2.99008 1.49415 4.624 0.514812 6.43928 0.15373C8.25456 -0.207351 10.1389 0.0721615 11.7712 0.944642C13.4035 1.81712 14.6827 3.22859 15.391 4.93854C16.0993 6.6485 16.1928 8.55114 15.6555 10.3223C15.1183 12.0934 13.9835 13.6235 12.4446 14.6518C10.9056 15.68 9.05779 16.1429 7.21587 15.9615C5.37394 15.7801 3.65189 14.9656 2.34315 13.6569L3.76867 12.2313C4.74761 13.2103 6.0357 13.8195 7.41347 13.9552C8.79123 14.0909 10.1734 13.7447 11.3245 12.9755C12.4756 12.2064 13.3245 11.0619 13.7263 9.73708C14.1282 8.41226 14.0583 6.98908 13.5285 5.71003C12.9987 4.43099 12.0418 3.37521 10.8208 2.7226C9.59988 2.06998 8.19041 1.8609 6.83258 2.13099C5.47475 2.40108 4.25258 3.13362 3.37431 4.2038C2.49603 5.27398 2.016 6.61558 2.016 8.00001H4L1 12L-2 8.00001H0ZM10.707 5.29298C10.3165 4.90246 9.68334 4.90246 9.29282 5.29298L7.99999 6.58581L6.71107 5.29689C6.32055 4.90636 5.68739 4.90636 5.29686 5.29689C4.90634 5.68741 4.90634 6.32058 5.29686 6.7111L6.58578 8.00002L5.29687 9.28893C4.90635 9.67945 4.90635 10.3126 5.29687 10.7031C5.6874 11.0937 6.32056 11.0937 6.71109 10.7031L7.99999 9.41423L9.29085 10.7051C9.68137 11.0956 10.3145 11.0956 10.7051 10.7051C11.0956 10.3146 11.0956 9.6814 10.7051 9.29088L9.41421 8.00002L10.707 6.7072C11.0976 6.31667 11.0976 5.68351 10.707 5.29298Z",
    fill: "currentColor"
  }))), _symbol211 || (_symbol211 = /*#__PURE__*/React.createElement("symbol", {
    id: "text",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 2,
    width: 12,
    height: 16,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 5,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 8,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 6,
    height: 2,
    fill: "currentColor"
  }))), _symbol212 || (_symbol212 = /*#__PURE__*/React.createElement("symbol", {
    id: "text2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    x: 1,
    width: 14,
    height: 16,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 4,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 9,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 10,
    height: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 7,
    height: 2,
    fill: "currentColor"
  }))), _symbol213 || (_symbol213 = /*#__PURE__*/React.createElement("symbol", {
    id: "text3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.66667C2 2.29848 2.29848 2 2.66667 2H13.3333C13.7015 2 14 2.29848 14 2.66667V4C14 4.36819 13.7015 4.66667 13.3333 4.66667C12.9651 4.66667 12.6667 4.36819 12.6667 4V3.33333H8.66667V12.6667H9.33333C9.70152 12.6667 10 12.9651 10 13.3333C10 13.7015 9.70152 14 9.33333 14H6.66667C6.29848 14 6 13.7015 6 13.3333C6 12.9651 6.29848 12.6667 6.66667 12.6667H7.33333V3.33333H3.33333V4C3.33333 4.36819 3.03486 4.66667 2.66667 4.66667C2.29848 4.66667 2 4.36819 2 4V2.66667Z",
    fill: "currentColor"
  }))), _symbol214 || (_symbol214 = /*#__PURE__*/React.createElement("symbol", {
    id: "text_input",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    y: 3,
    width: 16,
    height: 10,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0H12V16H10V0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0H14V2H8V0ZM8 14H14V16H8V14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9H6.5",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5L5 5.5L2.5 10.5",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol215 || (_symbol215 = /*#__PURE__*/React.createElement("symbol", {
    id: "time",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C7.44772 2 7 2.44772 7 3V8C7 8.377 7.20862 8.70528 7.51672 8.87568L10.4957 10.5956C10.974 10.8717 11.5856 10.7079 11.8617 10.2296C12.1379 9.75127 11.974 9.13968 11.4957 8.86354L9 7.42265V3C9 2.44772 8.55228 2 8 2Z",
    fill: "currentColor"
  }))), _symbol216 || (_symbol216 = /*#__PURE__*/React.createElement("symbol", {
    id: "time2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 3C7 2.44772 7.44772 2 8 2C8.55228 2 9 2.44772 9 3V7.42265L11.4957 8.86354C11.974 9.13968 12.1379 9.75127 11.8617 10.2296C11.5856 10.7079 10.974 10.8717 10.4957 10.5956L7.51672 8.87568C7.20862 8.70528 7 8.377 7 8V3Z",
    fill: "currentColor"
  }))), _symbol217 || (_symbol217 = /*#__PURE__*/React.createElement("symbol", {
    id: "transform",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 3V1H2L9 7.5L2 15H13L14 13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol218 || (_symbol218 = /*#__PURE__*/React.createElement("symbol", {
    id: "transform2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 3.5V1.5H2.5L8.5 7.5L2.5 14.5H12.5L13.5 12.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol219 || (_symbol219 = /*#__PURE__*/React.createElement("symbol", {
    id: "transform3",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4V2H3L9 7.5L3 14H12L13 12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol220 || (_symbol220 = /*#__PURE__*/React.createElement("symbol", {
    id: "transform4",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4V2.5H3L9 7.5L3 13.5H12L13 12",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol221 || (_symbol221 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72361.55279C5.893.214 6.23926 0 6.61803 0H9.38197C9.76074 0 10.107.214 10.2764.55279L10.5 1H5.5L5.72361.55279ZM2 2C2 1.44772 2.44772 1 3 1H13C13.5523 1 14 1.44772 14 2V3H2V2Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4H2V14C2 15.1046 2.89543 16 4 16H12C13.1046 16 14 15.1046 14 14V4ZM4 6H5.5V14H4V6ZM8.75 6H7.25V14H8.75V6ZM12 6H10.5V14H12V6Z",
    fill: "currentColor"
  }))), _symbol222 || (_symbol222 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash_small",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94488 3.33334C5.45918 2.15632 6.63315 1.33334 8.00061 1.33334C9.36814 1.33334 10.5421 2.15632 11.0564 3.33334H14C14.3682 3.33334 14.6667 3.63182 14.6667 4C14.6667 4.36819 14.3682 4.66667 14 4.66667H13.2904L12.7897 12.1774C12.6963 13.5782 11.5328 14.6667 10.1289 14.6667H5.87112C4.46721 14.6667 3.30374 13.5782 3.21036 12.1774L2.70964 4.66667H2.00001C1.63182 4.66667 1.33334 4.36819 1.33334 4C1.33334 3.63182 1.63182 3.33334 2.00001 3.33334H4.94488ZM6.50975 3.33334C6.87621 2.92408 7.40868 2.66667 8.00061 2.66667C8.59261 2.66667 9.12508 2.92408 9.49154 3.33334H6.50975ZM7.33334 7.33334C7.33334 6.96514 7.03488 6.66667 6.66668 6.66667C6.29849 6.66667 6.00001 6.96514 6.00001 7.33334V10.6667C6.00001 11.0349 6.29849 11.3333 6.66668 11.3333C7.03488 11.3333 7.33334 11.0349 7.33334 10.6667V7.33334ZM9.33334 6.66667C9.70154 6.66667 10 6.96514 10 7.33334V10.6667C10 11.0349 9.70154 11.3333 9.33334 11.3333C8.96514 11.3333 8.66668 11.0349 8.66668 10.6667V7.33334C8.66668 6.96514 8.96514 6.66667 9.33334 6.66667Z",
    fill: "currentColor"
  }))), _symbol223 || (_symbol223 = /*#__PURE__*/React.createElement("symbol", {
    id: "undo",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13807 1.52859C5.39842 1.78894 5.39842 2.21105 5.13807 2.4714L4.27614 3.33333H9C11.7614 3.33333 14 5.57191 14 8.33333C14 11.0948 11.7614 13.3333 9 13.3333H4C3.63181 13.3333 3.33333 13.0349 3.33333 12.6667C3.33333 12.2985 3.63181 12 4 12H9C11.025 12 12.6667 10.3584 12.6667 8.33333C12.6667 6.30829 11.025 4.66667 9 4.66667H4.27614L5.13807 5.52859C5.39842 5.78894 5.39842 6.21105 5.13807 6.4714C4.87772 6.73175 4.45561 6.73175 4.19526 6.4714L2.19526 4.4714C1.93491 4.21105 1.93491 3.78894 2.19526 3.52859L4.19526 1.52859C4.45561 1.26824 4.87772 1.26824 5.13807 1.52859Z",
    fill: "currentColor"
  }))), _symbol224 || (_symbol224 = /*#__PURE__*/React.createElement("symbol", {
    id: "union",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.56
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 13,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 13,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 13,
    width: 3,
    height: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5V11M5 8H11",
    stroke: "currentColor"
  })))), _symbol225 || (_symbol225 = /*#__PURE__*/React.createElement("symbol", {
    id: "unstable",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61899 9.3058L3.03905 10.7305H3.04112C3.01142 10.8186 2.99608 10.9086 2.99608 11C2.99608 12.1046 5.23553 13 7.99804 13C10.7605 13 13 12.1046 13 11C13 10.9084 12.9846 10.8183 12.9548 10.73H12.957L12.377 9.30368L15.7392 11.0733C16.0893 11.2576 16.0968 11.7562 15.7524 11.951L8.98439 15.7779C8.37356 16.1233 7.6264 16.1233 7.01558 15.7779L0.247552 11.951C-0.0968657 11.7562 -0.0893506 11.2576 0.26078 11.0733L3.61899 9.3058Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99773 7C9.65799 7 11.0039 6.55228 11.0039 6 11.0039 5.95813 10.9962 5.91686 10.9811 5.87634H10.9831L11.9621 8.28355H11.9564C11.9836 8.35423 11.9977 8.4265 11.9977 8.5 11.9977 9.32843 10.2063 10 7.99644 10 5.78659 10 3.99515 9.32843 3.99515 8.5 3.99515 8.4265 4.00925 8.35423 4.0365 8.28355H4.03513L5.00982 5.88911C4.99774 5.92552 4.99155 5.96252 4.99155 6 4.99155 6.55228 6.33746 7 7.99773 7ZM8.32716 1C8.73397 1 9.10024 1.24644 9.25349 1.62328L10.1976 3.94476C10.2005 3.95065 10.2029 3.95656 10.2048 3.96251L10.205 3.96291H10.2049C10.2089 3.97515 10.2109 3.98752 10.2109 4 10.2109 4.27614 9.22107 4.5 8 4.5 6.77893 4.5 5.78906 4.27614 5.78906 4 5.78906 3.98752 5.79108 3.97515 5.79505 3.96291H5.79391L6.74642 1.62297C6.89975 1.2463 7.26593 1 7.67262 1H8.32716Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67261 1C7.26592 1 6.89974 1.2463 6.74641 1.62297L3.03906 10.7305H3.04113C3.01143 10.8186 2.99609 10.9086 2.99609 11C2.99609 12.1046 5.23554 13 7.99805 13C10.7605 13 13 12.1046 13 11C13 10.9084 12.9846 10.8183 12.9548 10.73H12.957L9.25348 1.62328C9.10022 1.24644 8.73396 1 8.32715 1H7.67261Z",
    fill: "currentColor"
  }))), _symbol226 || (_symbol226 = /*#__PURE__*/React.createElement("symbol", {
    id: "unstable2",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92359 8.55752L3.03906 10.7305H3.04113C3.01143 10.8186 2.99609 10.9086 2.99609 11C2.99609 12.1046 5.23554 13 7.99804 13C10.7605 13 13 12.1046 13 11C13 10.9084 12.9846 10.8183 12.9548 10.73H12.957L12.0731 8.55655C14.4239 9.25322 16 10.5346 16 12C16 14.2092 12.4183 16 8 16C3.58172 16 0 14.2092 0 12C0 10.5353 1.57459 9.25442 3.92359 8.55752Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99773 7C9.65799 7 11.0039 6.55228 11.0039 6 11.0039 5.95813 10.9962 5.91686 10.9811 5.87634H10.9831L11.9621 8.28355H11.9564C11.9836 8.35423 11.9977 8.4265 11.9977 8.5 11.9977 9.32843 10.2063 10 7.99644 10 5.78659 10 3.99515 9.32843 3.99515 8.5 3.99515 8.4265 4.00925 8.35423 4.0365 8.28355H4.03513L5.00982 5.88911C4.99774 5.92552 4.99155 5.96252 4.99155 6 4.99155 6.55228 6.33746 7 7.99773 7ZM8.32716 1C8.73397 1 9.10024 1.24644 9.25349 1.62328L10.1976 3.94476C10.2005 3.95065 10.2029 3.95656 10.2048 3.96251L10.205 3.96291H10.2049C10.2089 3.97515 10.2109 3.98752 10.2109 4 10.2109 4.27614 9.22107 4.5 8 4.5 6.77893 4.5 5.78906 4.27614 5.78906 4 5.78906 3.98752 5.79108 3.97515 5.79505 3.96291H5.79391L6.74642 1.62297C6.89975 1.2463 7.26593 1 7.67262 1H8.32716Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67261 1C7.26592 1 6.89974 1.2463 6.74641 1.62297L3.03906 10.7305H3.04113C3.01143 10.8186 2.99609 10.9086 2.99609 11C2.99609 12.1046 5.23554 13 7.99805 13C10.7605 13 13 12.1046 13 11C13 10.9084 12.9846 10.8183 12.9548 10.73H12.957L9.25348 1.62328C9.10022 1.24644 8.73396 1 8.32715 1H7.67261Z",
    fill: "currentColor"
  }))), _symbol227 || (_symbol227 = /*#__PURE__*/React.createElement("symbol", {
    id: "untrash",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72361 0.552786C5.893 0.214002 6.23926 0 6.61803 0H9.38197C9.76074 0 10.107 0.214002 10.2764 0.552786L10.5 1H13C13.5523 1 14 1.44772 14 2V3H2V2C2 1.44772 2.44772 1 3 1H5.5L5.72361 0.552786ZM14 4H2V14C2 15.1046 2.89543 16 4 16H12C13.1046 16 14 15.1046 14 14V4ZM8 6.5L11 10.5H9V12.5C9 13.0523 8.55228 13.5 8 13.5C7.44772 13.5 7 13.0523 7 12.5V10.5H5L8 6.5Z",
    fill: "currentColor"
  }))), _symbol228 || (_symbol228 = /*#__PURE__*/React.createElement("symbol", {
    id: "vector_add",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM7 7V3H9V7H13V9H9V13H7V9H3V7H7Z",
    fill: "currentColor"
  }))), _symbol229 || (_symbol229 = /*#__PURE__*/React.createElement("symbol", {
    id: "versions",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.66667V4C10 2.89543 9.1046 2 8 2H5.33334C4.22877 2 3.33334 2.89543 3.33334 4V9.33333C3.33334 10.4379 4.22877 11.3333 5.33334 11.3333H6M10.6667 14H8C6.8954 14 6 13.1046 6 12V6.66667C6 5.5621 6.8954 4.66667 8 4.66667H10.6667C11.7713 4.66667 12.6667 5.5621 12.6667 6.66667V12C12.6667 13.1046 11.7713 14 10.6667 14Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _symbol230 || (_symbol230 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.33334C8.23527 1.33334 8.45312 1.45735 8.57324 1.65965L14.9066 12.3263C15.0289 12.5324 15.0313 12.7882 14.9127 12.9965C14.7942 13.2047 14.573 13.3333 14.3333 13.3333H1.66667C1.42703 13.3333 1.20584 13.2047 1.08729 12.9965C0.968745 12.7882 0.971089 12.5324 1.09343 12.3263L7.42676 1.65965C7.54688 1.45735 7.76473 1.33334 8 1.33334ZM8 6.00001C8.36819 6.00001 8.66667 6.29849 8.66667 6.66668V8.00001C8.66667 8.3682 8.36819 8.66668 8 8.66668C7.63181 8.66668 7.33333 8.3682 7.33333 8.00001V6.66668C7.33333 6.29849 7.63181 6.00001 8 6.00001ZM7.16667 10C7.16667 9.53977 7.53976 9.16668 8 9.16668C8.46024 9.16668 8.83333 9.53977 8.83333 10C8.83333 10.4602 8.46024 10.8333 8 10.8333C7.53976 10.8333 7.16667 10.4602 7.16667 10Z",
    fill: "currentColor"
  }))), _symbol231 || (_symbol231 = /*#__PURE__*/React.createElement("symbol", {
    id: "workflow_play",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.48492 3.22331L11.5227 7.12544C12.2095 7.50623 12.2095 8.49377 11.5227 8.87457L4.48491 12.7767C3.8184 13.1462 3.00001 12.6642 3.00001 11.9021L3.00001 4.09788C3.00001 3.33576 3.8184 2.85376 4.48492 3.22331Z",
    fill: "currentColor"
  }))), _symbol232 || (_symbol232 = /*#__PURE__*/React.createElement("symbol", {
    id: "zoom",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 5.33333V9.33333M9.33333 7.33333L5.33333 7.33333M13.3333 13.3333L10.7 10.7M12 7.33333C12 9.91066 9.91066 12 7.33333 12C4.756 12 2.66667 9.91066 2.66667 7.33333C2.66667 4.756 4.756 2.66666 7.33333 2.66666C9.91066 2.66666 12 4.756 12 7.33333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.2fd39f709e9037bc5ad490252e17467b.svg";
export { ForwardRef as ReactComponent };